"use client";

import { Icon } from "./Icon";

export function NavIcon({
  icon,
  className,
  size = 32,
  active = false,
  strokeWidth = 1.5,
}) {
  switch (icon) {
    case "accessibility":
      return (
        <Accessibility
          className={className}
          size={size}
          active={active}
          strokeWidth={strokeWidth}
        />
      );

    case "rides":
      return (
        <Rides
          className={className}
          size={size}
          active={active}
          strokeWidth={strokeWidth}
        />
      );

    case "parking":
      return (
        <Parking
          className={className}
          size={size}
          active={active}
          strokeWidth={strokeWidth}
        />
      );

    case "map":
      return (
        <Map
          className={className}
          size={size}
          active={active}
          strokeWidth={strokeWidth}
        />
      );

    case "safety":
      return (
        <Safety
          className={className}
          size={size}
          active={active}
          strokeWidth={strokeWidth}
        />
      );

    case "getting-here":
      return (
        <GettingHere
          className={className}
          size={size}
          active={active}
          strokeWidth={strokeWidth}
        />
      );

    case "clock":
      return (
        <Clock
          className={className}
          size={size}
          active={active}
          strokeWidth={strokeWidth}
        />
      );

    case "drama-masks":
      return (
        <DramaMasks
          className={className}
          size={size}
          active={active}
          strokeWidth={strokeWidth}
        />
      );

    case "bag":
      return (
        <Bag
          className={className}
          size={size}
          active={active}
          strokeWidth={strokeWidth}
        />
      );

    case "displays":
      return (
        <Competition
          className={className}
          size={size}
          active={active}
          strokeWidth={1}
        />
      );

    case "animal":
      return (
        <Animal
          className={className}
          size={size}
          active={active}
          strokeWidth={strokeWidth}
        />
      );

    case "education":
      return (
        <Education
          className={className}
          size={size}
          active={active}
          strokeWidth={strokeWidth}
        />
      );

    case "commercial-exhibitors":
      return (
        <CommercialExhibitors
          className={className}
          size={size}
          active={active}
          strokeWidth={1}
        />
      );

    case "goyder-pavilion":
      return (
        <GoyderPavilion
          className={className}
          size={size}
          active={active}
          strokeWidth={strokeWidth}
        />
      );

    case "jubilee-pavilion":
      return (
        <JubileePavilion
          className={className}
          size={size}
          active={active}
          strokeWidth={strokeWidth}
        />
      );

    case "market-bazaar":
      return (
        <MarketBazaar
          className={className}
          size={size}
          active={active}
          strokeWidth={strokeWidth}
        />
      );

    case "taste-sa":
      return (
        <TasteSA
          className={className}
          size={size}
          active={active}
          strokeWidth={1}
        />
      );

    case "dairy-food-hall":
      return (
        <DairyFoodHall
          className={className}
          size={size}
          active={active}
          strokeWidth={1}
        />
      );

    case "comp-judging":
      return (
        <CompJudging
          className={className}
          size={size}
          active={active}
          strokeWidth={1}
        />
      );

    case "yellow-brick-road":
      return (
        <YellowBrickRoad
          className={className}
          size={size}
          active={active}
          strokeWidth={strokeWidth}
        />
      );

    case "cellar-door":
      return (
        <CellarDoor
          className={className}
          size={size}
          active={active}
          strokeWidth={1}
        />
      );

    case "comps":
      return (
        <Comps
          className={className}
          size={size}
          active={active}
          strokeWidth={1}
        />
      );

    case "comp-results":
      return (
        <CompResults
          className={className}
          size={size}
          active={active}
          strokeWidth={1}
        />
      );

    case "main-arena":
      return (
        <MainArena
          className={className}
          size={size}
          active={active}
          strokeWidth={1}
        />
      );

    case "boulevard-stage":
      return (
        <BoulevardStage
          className={className}
          size={size}
          active={active}
          strokeWidth={1}
        />
      );

    case "kids-mid-week":
      return (
        <KidsMidWeek
          className={className}
          size={size}
          active={active}
          strokeWidth={1}
        />
      );

    case "night-shift":
      return (
        <NightShift
          className={className}
          size={size}
          active={active}
          strokeWidth={1}
        />
      );

    case "goyder-stage":
      return (
        <GoyderStage
          className={className}
          size={size}
          active={active}
          strokeWidth={1}
        />
      );

    case "horticulture-stage":
      return (
        <HorticultureStage
          className={className}
          size={size}
          active={active}
          strokeWidth={1}
        />
      );

    case "kingsway":
      return (
        <Kingsway
          className={className}
          size={size}
          active={active}
          strokeWidth={1}
        />
      );

    case "about-the-show":
      return <AboutTheShow
        className={className}
        size={size}
        active={active}
        strokeWidth={strokeWidth}
      />;

    case "show-history":
      return <ShowHistory
        className={className}
        size={size}
        active={active}
        strokeWidth={strokeWidth}
      />;

    case "society-foundation":
      return <SocietyFoundation
        className={className}
        size={size}
        active={active}
        strokeWidth={strokeWidth}
      />;

    case "partners-and-sponsors":
      return <PartnersAndSponsors
        className={className}
        size={size}
        active={active}
        strokeWidth={strokeWidth}
      />;

    case "volunteer":
      return <Volunteer
        className={className}
        size={size}
        active={active}
        strokeWidth={strokeWidth}
      />;

    case "become-an-exhibitor":
      return <BecomeAnExhibitor
        className={className}
        size={size}
        active={active}
        strokeWidth={strokeWidth}
      />;

    case "rh-hs-membership":
      return <RhHsMembership
        className={className}
        size={size}
        active={active}
        strokeWidth={strokeWidth}
      />;

    case "work-with-us":
      return <WorkWithUs
        className={className}
        size={size}
        active={active}
        strokeWidth={strokeWidth}
      />;

    case "comp_info":
      return <CompInfo
        className={className}
        size={size}
        active={active}
        strokeWidth={strokeWidth}
      />;

    case "volunteer":
      return <Volunteer
        className={className}
        size={size}
        active={active}
        strokeWidth={strokeWidth}
      />;

    case "become-an-exhibitor":
      return <BecomeAnExhibitor
        className={className}
        size={size}
        active={active}
        strokeWidth={strokeWidth}
      />;

    case "rh-hs-membership":
      return <RhHsMembership
        className={className}
        size={size}
        active={active}
        strokeWidth={strokeWidth}
      />;

    case "work-with-us":
      return <WorkWithUs
        className={className}
        size={size}
        active={active}
        strokeWidth={strokeWidth}
      />;

    case "comp-info":
      return <CompInfo
        className={className}
        size={size}
        active={active}
        strokeWidth={strokeWidth}
      />;

    default:
      return (
        <span
          className={`flex size-full items-center justify-center text-header-foreground transition-colors duration-300 group-hover:text-header [&_svg]:stroke-header-foreground [&_svg]:transition-colors [&_svg]:duration-300 group-hover:[&_svg]:stroke-header ${className ?? ""}`}
        >
          <Icon icon={icon} size={size} strokeWidth={strokeWidth} />
        </span>
      );
  }
}



function ShowHistory({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      viewBox="0 0 53 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="M27.12 8.34H25.62V39.66H27.12V8.34Z" className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path
          d="M28.13 45.16H24.62C23.73 45.16 22.9 44.71 22.4 43.94C21.3 42.25 19.72 41.36 17.83 41.36H3.6C1.62 41.36 0 39.75 0 37.76V9.29C0 7.31 1.61 5.69 3.6 5.69H6.45V7.19H3.6C2.44 7.19 1.5 8.13 1.5 9.29V37.76C1.5 38.92 2.44 39.86 3.6 39.86H17.84C20.26 39.86 22.27 40.99 23.66 43.12C23.88 43.45 24.24 43.66 24.62 43.66H28.13C28.51 43.66 28.88 43.46 29.09 43.13C30.48 41 32.5 39.87 34.91 39.87H49.15C50.31 39.87 51.25 38.93 51.25 37.77V9.29C51.25 8.13 50.31 7.19 49.15 7.19H46.3V5.69H49.15C51.13 5.69 52.75 7.3 52.75 9.29V37.76C52.75 39.74 51.14 41.36 49.15 41.36H34.91C33.03 41.36 31.45 42.25 30.34 43.94C29.84 44.7 29.01 45.15 28.12 45.15L28.13 45.16Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M26.37 41.36C25.96 41.36 25.62 41.02 25.62 40.61C25.62 36.04 19.85 30.92 12.13 30.92C11.72 30.92 11.38 30.58 11.38 30.17V0.75C11.38 0.34 11.72 0 12.13 0C18.78 0 24.4 3.27 26.37 6.73C28.34 3.27 33.95 0 40.61 0C41.02 0 41.36 0.34 41.36 0.75V30.17C41.36 30.58 41.02 30.92 40.61 30.92C32.89 30.92 27.12 36.04 27.12 40.61C27.12 41.02 26.78 41.36 26.37 41.36ZM12.89 29.44C19.02 29.69 24.44 32.99 26.38 37.25C28.31 32.99 33.74 29.69 39.87 29.44V1.51C32.44 1.79 27.13 6.25 27.13 9.29C27.13 9.7 26.79 10.04 26.38 10.04C25.97 10.04 25.63 9.7 25.63 9.29C25.63 6.25 20.33 1.8 12.89 1.51V29.43V29.44Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M26.37 41.36C26.16 41.36 25.96 41.27 25.82 41.12C20.84 35.67 16.03 35.67 6.44 35.67C6.03 35.67 5.69 35.33 5.69 34.92V3.60001C5.69 3.19001 6.03 2.85001 6.44 2.85001C8.65 2.85001 10.48 2.85001 12.16 2.91001L12.11 4.41001C10.64 4.36001 9.06 4.35001 7.19 4.35001V34.17C16.11 34.17 21.27 34.31 26.37 39.52C31.47 34.31 36.63 34.17 45.55 34.17V4.35001C43.69 4.35001 42.1 4.36001 40.63 4.41001L40.58 2.91001C42.27 2.85001 44.09 2.85001 46.3 2.85001C46.71 2.85001 47.05 3.19001 47.05 3.60001V34.92C47.05 35.33 46.71 35.67 46.3 35.67C36.71 35.67 31.9 35.67 26.92 41.12C26.78 41.28 26.58 41.36 26.37 41.36Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
      </g>
    </svg>
  );
}

function SocietyFoundation({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      height={40}
      viewBox="0 0 24 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M11.23 30.62C9.38 30.62 5.56 30.27 2.96 27.67C0.170004 24.88 -0.0399961 20.71 3.89572e-06 19.04C3.89572e-06 18.64 0.330004 18.32 0.730004 18.31C2.4 18.26 6.57 18.47 9.36 21.26C12.15 24.05 12.35 28.22 12.31 29.89C12.31 30.29 11.98 30.61 11.58 30.62C11.47 30.62 11.35 30.62 11.22 30.62H11.23ZM1.51 19.81C1.56 21.55 1.97 24.56 4.02 26.61C6.07 28.66 9.08 29.07 10.82 29.12C10.77 27.38 10.36 24.37 8.31 22.32C6.26 20.28 3.25 19.86 1.51 19.81Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M11.91 30.62C11.78 30.62 11.66 30.62 11.55 30.62C11.15 30.61 10.83 30.29 10.82 29.89C10.78 28.22 10.98 24.05 13.77 21.26C16.56 18.47 20.73 18.26 22.4 18.31C22.8 18.32 23.12 18.64 23.13 19.04C23.17 20.71 22.97 24.88 20.18 27.67C17.58 30.28 13.76 30.62 11.91 30.62ZM21.63 19.81C19.89 19.86 16.88 20.27 14.83 22.32C12.79 24.36 12.37 27.38 12.32 29.12C14.06 29.07 17.07 28.66 19.12 26.61C21.16 24.57 21.58 21.55 21.63 19.81Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M11.23 39.77C9.38 39.77 5.56 39.42 2.96 36.82C0.170004 34.04 -0.0399961 29.86 3.89572e-06 28.19C3.89572e-06 27.79 0.330004 27.47 0.730004 27.46C2.39 27.44 6.57 27.62 9.36 30.41C12.15 33.2 12.35 37.37 12.31 39.04C12.31 39.44 11.98 39.76 11.58 39.77C11.47 39.77 11.35 39.77 11.22 39.77H11.23ZM1.51 28.96C1.56 30.7 1.97 33.71 4.02 35.76C6.07 37.81 9.08 38.22 10.82 38.27C10.77 36.53 10.36 33.52 8.31 31.47C6.26 29.42 3.25 29.01 1.51 28.96Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M11.91 39.77C11.78 39.77 11.66 39.77 11.55 39.77C11.15 39.76 10.83 39.44 10.82 39.04C10.78 37.37 10.98 33.2 13.77 30.41C16.56 27.62 20.75 27.44 22.4 27.46C22.8 27.46 23.12 27.79 23.13 28.19C23.17 29.86 22.97 34.03 20.18 36.82C17.58 39.42 13.76 39.77 11.91 39.77ZM21.63 28.96C19.89 29.01 16.88 29.42 14.83 31.47C12.78 33.52 12.37 36.53 12.32 38.27C14.06 38.22 17.07 37.81 19.12 35.76C21.16 33.72 21.58 30.7 21.63 28.96Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M11.23 21.47C9.39001 21.47 5.56001 21.12 2.95001 18.52C0.170006 15.73 -0.0399937 11.55 6.28829e-06 9.89001C6.28829e-06 9.49001 0.330006 9.17001 0.730006 9.16001C2.39001 9.14001 6.57001 9.32001 9.36001 12.11C12.15 14.9 12.35 19.07 12.31 20.74C12.31 21.14 11.98 21.46 11.58 21.47C11.47 21.47 11.36 21.47 11.23 21.47ZM1.51001 10.66C1.56001 12.4 1.97001 15.41 4.02001 17.46C6.07001 19.51 9.08001 19.92 10.82 19.97C10.77 18.23 10.36 15.22 8.31001 13.17C6.26001 11.12 3.25001 10.71 1.51001 10.66Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M11.9 21.47C11.77 21.47 11.66 21.47 11.55 21.47C11.15 21.47 10.83 21.14 10.82 20.74C10.78 19.07 10.98 14.9 13.77 12.11C16.56 9.32 20.75 9.13 22.4 9.16C22.8 9.16 23.12 9.49 23.13 9.89C23.17 11.56 22.97 15.73 20.18 18.52C17.57 21.13 13.75 21.47 11.9 21.47ZM21.63 10.66C19.89 10.71 16.88 11.12 14.83 13.17C12.78 15.22 12.37 18.23 12.32 19.97C14.06 19.92 17.07 19.51 19.12 17.46C21.17 15.41 21.58 12.4 21.63 10.66Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M11.57 13.98C9.16 13.98 6.7 12.35 6.66 9.23V9.11C6.66 4.83 9.73 1.46 11.05 0.199998C11.34 -0.0700024 11.79 -0.0700024 12.08 0.199998C13.4 1.45 16.47 4.82 16.47 9.11V9.24C16.43 12.35 13.97 13.98 11.56 13.98H11.57ZM11.57 1.81C10.25 3.19 8.16 5.88 8.16 9.11C8.16 9.11 8.16 9.2 8.16 9.21C8.19 11.47 9.89 12.48 11.57 12.48C13.25 12.48 14.95 11.47 14.98 9.21C14.98 5.89 12.89 3.19 11.57 1.81Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path d="M12.32 13.23H10.82V42.35H12.32V13.23Z" className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
      </g>
    </svg>
  );
}

function PartnersAndSponsors({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      viewBox="0 0 40 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_27)">
        <path
          d="M20.99 6.4H18.09C17.13 6.4 16.34 5.61 16.34 4.65V1.75C16.34 0.79 17.13 0 18.09 0H20.99C21.95 0 22.74 0.79 22.74 1.75V4.65C22.74 5.61 21.95 6.4 20.99 6.4ZM18.09 1.5C17.95 1.5 17.84 1.61 17.84 1.75V4.65C17.84 4.79 17.95 4.9 18.09 4.9H20.99C21.13 4.9 21.24 4.79 21.24 4.65V1.75C21.24 1.61 21.13 1.5 20.99 1.5H18.09Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path
          d="M20.99 43.98H18.09C17.13 43.98 16.34 43.19 16.34 42.23V39.33C16.34 38.37 17.13 37.58 18.09 37.58H20.99C21.95 37.58 22.74 38.37 22.74 39.33V42.23C22.74 43.19 21.95 43.98 20.99 43.98ZM18.09 39.08C17.95 39.08 17.84 39.19 17.84 39.33V42.23C17.84 42.37 17.95 42.48 18.09 42.48H20.99C21.13 42.48 21.24 42.37 21.24 42.23V39.33C21.24 39.19 21.13 39.08 20.99 39.08H18.09Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path
          d="M37.33 16.2H34.43C33.47 16.2 32.68 15.41 32.68 14.45V11.55C32.68 10.59 33.47 9.79999 34.43 9.79999H37.33C38.29 9.79999 39.08 10.59 39.08 11.55V14.45C39.08 15.41 38.29 16.2 37.33 16.2ZM34.43 11.3C34.29 11.3 34.18 11.41 34.18 11.55V14.45C34.18 14.59 34.29 14.7 34.43 14.7H37.33C37.47 14.7 37.58 14.59 37.58 14.45V11.55C37.58 11.41 37.47 11.3 37.33 11.3H34.43Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path
          d="M4.65 34.18H1.75C0.79 34.18 0 33.39 0 32.43V29.53C0 28.57 0.79 27.78 1.75 27.78H4.65C5.61 27.78 6.4 28.57 6.4 29.53V32.43C6.4 33.39 5.61 34.18 4.65 34.18ZM1.75 29.28C1.61 29.28 1.5 29.39 1.5 29.53V32.43C1.5 32.57 1.61 32.68 1.75 32.68H4.65C4.79 32.68 4.9 32.57 4.9 32.43V29.53C4.9 29.39 4.79 29.28 4.65 29.28H1.75Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path
          d="M4.65 16.2H1.75C0.79 16.2 0 15.41 0 14.45V11.55C0 10.59 0.79 9.79999 1.75 9.79999H4.65C5.61 9.79999 6.4 10.59 6.4 11.55V14.45C6.4 15.41 5.61 16.2 4.65 16.2ZM1.75 11.3C1.61 11.3 1.5 11.41 1.5 11.55V14.45C1.5 14.59 1.61 14.7 1.75 14.7H4.65C4.79 14.7 4.9 14.59 4.9 14.45V11.55C4.9 11.41 4.79 11.3 4.65 11.3H1.75Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path
          d="M37.33 34.18H34.43C33.47 34.18 32.68 33.39 32.68 32.43V29.53C32.68 28.57 33.47 27.78 34.43 27.78H37.33C38.29 27.78 39.08 28.57 39.08 29.53V32.43C39.08 33.39 38.29 34.18 37.33 34.18ZM34.43 29.28C34.29 29.28 34.18 29.39 34.18 29.53V32.43C34.18 32.57 34.29 32.68 34.43 32.68H37.33C37.47 32.68 37.58 32.57 37.58 32.43V29.53C37.58 29.39 37.47 29.28 37.33 29.28H34.43Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path d="M20.29 24.44H18.79V38.33H20.29V24.44Z" className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path d="M20.29 5.64999H18.79V17.9H20.29V5.64999Z" className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path
          d="M19.54 25.19C17.33 25.19 15.52 23.39 15.52 21.17C15.52 18.95 17.32 17.15 19.54 17.15C21.76 17.15 23.56 18.95 23.56 21.17C23.56 23.39 21.76 25.19 19.54 25.19ZM19.54 18.66C18.15 18.66 17.02 19.79 17.02 21.18C17.02 22.57 18.15 23.7 19.54 23.7C20.93 23.7 22.06 22.57 22.06 21.18C22.06 19.79 20.93 18.66 19.54 18.66Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path
          d="M16.3397 22.1472L5.24594 28.5522L5.99594 29.8512L17.0897 23.4462L16.3397 22.1472Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path
          d="M6.0256 12.4997L5.2756 13.7987L16.3434 20.1887L17.0934 18.8897L6.0256 12.4997Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path
          d="M22.7341 22.1497L21.9841 23.4488L33.0779 29.8538L33.8279 28.5547L22.7341 22.1497Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path
          d="M33.0474 12.51L21.9796 18.9L22.7296 20.199L33.7974 13.809L33.0474 12.51Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path
          d="M37.52 28.82L36.14 28.23C37.09 25.99 37.57 23.62 37.57 21.17C37.57 19.3 37.28 17.45 36.72 15.68L38.15 15.22C38.76 17.14 39.07 19.14 39.07 21.17C39.07 23.82 38.55 26.39 37.52 28.82Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path
          d="M22.09 40.54L21.9 39.05C26.34 38.47 30.39 36.26 33.3 32.83L34.44 33.8C31.29 37.51 26.9 39.91 22.09 40.53V40.54Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path
          d="M16.99 40.54C12.18 39.91 7.79001 37.52 4.64001 33.81L5.78001 32.84C8.69002 36.27 12.74 38.48 17.18 39.06L16.99 40.55V40.54Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path
          d="M1.55 28.82C0.52 26.4 0 23.83 0 21.17C0 19.15 0.31 17.15 0.92 15.22L2.35 15.68C1.78 17.46 1.5 19.3 1.5 21.17C1.5 23.62 1.98 25.99 2.93 28.23L1.55 28.82Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path
          d="M4.66001 10.98L3.42001 10.13C6.56001 5.54999 11.51 2.51999 16.99 1.79999L17.18 3.28999C12.12 3.94999 7.56001 6.74999 4.65001 10.98H4.66001Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path
          d="M34.42 10.98C31.52 6.74999 26.95 3.94999 21.89 3.28999L22.08 1.79999C27.56 2.50999 32.51 5.54999 35.65 10.12L34.41 10.97L34.42 10.98Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path
          d="M33.43 45.61H30.16C29.85 45.61 29.58 45.42 29.46 45.14L21.06 23.83L22.46 23.28L30.67 44.11H33.43V45.61Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path
          d="M8.91999 45.61H5.64999V44.11H8.40999L16.62 23.28L18.02 23.83L9.62999 45.14C9.51999 45.43 9.23999 45.62 8.92999 45.62L8.91999 45.61Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
      </g>
    </svg>
  );
}

function Volunteer({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_74)">
        <path
          d="M14.1 29.04V27.54C15.53 27.54 16.69 26.38 16.69 24.95V14.29C16.69 13.35 16.09 12.52 15.19 12.21C14.83 12.09 13.99 11.8 13.47 11.62L9.63 15.46C9.34 15.75 8.86 15.75 8.57 15.46L4.73 11.62C4.21 11.8 3.37 12.09 3 12.21C2.1 12.51 1.5 13.35 1.5 14.29V24.95C1.5 26.38 2.66 27.54 4.09 27.54V29.04C1.84 29.04 0 27.21 0 24.95V14.29C0 12.71 1.01 11.3 2.52 10.79C3.06 10.61 4.68 10.05 4.68 10.05C4.95 9.96 5.25 10.02 5.46 10.23L9.1 13.87L12.74 10.23C12.94 10.03 13.24 9.96 13.52 10.05C13.52 10.05 15.14 10.61 15.68 10.79C17.19 11.3 18.2 12.7 18.2 14.29V24.95C18.2 27.2 16.37 29.04 14.11 29.04H14.1Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M9.09999 9.85C6.38999 9.85 4.17999 7.64 4.17999 4.93C4.17999 2.22 6.37999 0 9.09999 0C11.82 0 14.02 2.21 14.02 4.92C14.02 7.63 11.81 9.84 9.09999 9.84V9.85ZM9.09999 1.5C7.20999 1.5 5.67999 3.04 5.67999 4.92C5.67999 6.8 7.21999 8.34 9.09999 8.34C10.98 8.34 12.52 6.8 12.52 4.92C12.52 3.04 10.98 1.5 9.09999 1.5Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M13.27 43.23H4.92C4.05 43.23 3.34 42.52 3.34 41.65V17.45H4.84V41.65C4.84 41.65 4.88 41.73 4.92 41.73H13.27C13.27 41.73 13.35 41.69 13.35 41.65V17.45H14.85V41.65C14.85 42.52 14.14 43.23 13.27 43.23Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M9.85001 27.46H8.35001V42.48H9.85001V27.46Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M26.62 43.23C21.46 43.23 16.69 40.88 13.51 36.79L14.7 35.87C17.59 39.59 21.94 41.73 26.63 41.73C34.96 41.73 41.74 34.95 41.74 26.62C41.74 18.29 34.96 11.51 26.63 11.51C23.46 11.51 20.41 12.49 17.83 14.35L16.95 13.13C19.79 11.08 23.13 10 26.63 10C35.79 10 43.24 17.45 43.24 26.61C43.24 35.77 35.79 43.22 26.63 43.22L26.62 43.23Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M26.62 29.88C24.83 29.88 23.37 28.42 23.37 26.63C23.37 24.84 24.83 23.38 26.62 23.38C28.41 23.38 29.87 24.84 29.87 26.63C29.87 28.42 28.41 29.88 26.62 29.88ZM26.62 24.87C25.65 24.87 24.87 25.66 24.87 26.62C24.87 27.58 25.66 28.37 26.62 28.37C27.58 28.37 28.37 27.58 28.37 26.62C28.37 25.66 27.58 24.87 26.62 24.87Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path d="M37.48 25.87H29.13V27.37H37.48V25.87Z" className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path
          d="M31.63 8.18H21.62C20.75 8.18 20.04 7.47 20.04 6.6V4.93C20.04 4.06 20.75 3.35 21.62 3.35H31.63C32.5 3.35 33.21 4.06 33.21 4.93V6.6C33.21 7.47 32.5 8.18 31.63 8.18ZM21.61 4.84C21.61 4.84 21.53 4.88 21.53 4.92V6.59C21.53 6.59 21.57 6.67 21.61 6.67H31.62C31.62 6.67 31.7 6.63 31.7 6.59V4.92C31.7 4.92 31.66 4.84 31.62 4.84H21.61Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path d="M24.87 7.43H23.37V10.97H24.87V7.43Z" className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path d="M29.88 7.43H28.38V10.98H29.88V7.43Z" className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path
          d="M36.23 23.51C34.88 19.33 31.02 16.52 26.62 16.52V15.02C31.67 15.02 36.1 18.25 37.65 23.05L36.22 23.51H36.23Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
      </g>
    </svg>
  );
}

function BecomeAnExhibitor({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      id="uuid-bd1e5295-4ecf-4abb-903f-621a17e4aa33"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 45.61 45.61"
    >
      <path
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        d="M19.27,45.61c-1.34,0-2.6-.52-3.54-1.47l-2.26-2.26c-.54-.54-.63-1.39-.22-2.03.73-1.13,1.01-2.51.78-3.87-.37-2.23-2.18-4.04-4.41-4.41-1.36-.23-2.73.05-3.87.78-.64.41-1.49.32-2.03-.22l-2.26-2.26c-1.95-1.95-1.95-5.13,0-7.08L22.79,1.46c1.95-1.95,5.13-1.95,7.08,0l2.26,2.26c.54.54.63,1.39.22,2.03-.73,1.13-1.01,2.51-.78,3.87.37,2.23,2.18,4.04,4.41,4.41,1.36.23,2.74-.05,3.87-.78.64-.41,1.49-.32,2.03.22l2.26,2.26c1.95,1.95,1.95,5.13,0,7.08l-21.33,21.33c-.95.95-2.21,1.47-3.54,1.47ZM8.7,30c.39,0,.78.03,1.17.1,2.85.47,5.17,2.79,5.64,5.64.29,1.73-.07,3.48-1,4.93-.03.05-.02.11.02.15l2.26,2.26c1.33,1.33,3.64,1.33,4.96,0l21.33-21.33c1.37-1.37,1.37-3.6,0-4.96l-2.26-2.26s-.1-.05-.15-.02c-1.45.94-3.2,1.29-4.93,1-2.85-.47-5.17-2.8-5.64-5.64-.29-1.73.07-3.48,1-4.93.03-.05.02-.11-.02-.15l-2.26-2.26c-1.37-1.37-3.59-1.37-4.96,0L2.52,23.85c-1.37,1.37-1.37,3.6,0,4.96l2.26,2.26s.11.05.15.02c1.12-.72,2.42-1.1,3.76-1.1Z"
      />
      <rect
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        x="17.97"
        y="6.79"
        width="1.5"
        height=".91"
        transform="translate(.36 15.36) rotate(-45)"
      />
      <rect
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        x="28.42"
        y="6.04"
        width="1.5"
        height="23.32"
        transform="translate(-3.97 25.81) rotate(-45)"
      />
      <path
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        d="M19.3,33.26c-.1,0-.21,0-.31-.03-.67-.12-1.2-.59-1.39-1.25l-.83-2.9c-.04-.12-.13-.22-.25-.25l-2.9-.83c-.65-.19-1.13-.72-1.25-1.39-.12-.67.15-1.34.71-1.74l2.69-1.94c.09-.07.15-.18.15-.3l.05-3.26c0-.66.38-1.26.98-1.56.59-.3,1.3-.24,1.83.16l2.48,1.82c.1.07.23.09.34.05l2.96-1.07c.65-.23,1.36-.08,1.84.41.49.49.65,1.2.41,1.84l-1.07,2.96c-.04.12-.02.25.05.35l1.82,2.48c.39.53.45,1.24.16,1.83-.3.59-.89.97-1.56.98l-3.27.05c-.12,0-.23.06-.29.15l-1.94,2.69c-.34.47-.87.74-1.43.74ZM17.74,19.14c-.05,0-.09.02-.12.03-.05.03-.15.09-.15.24l-.05,3.26c0,.59-.3,1.14-.77,1.49l-2.69,1.94c-.12.09-.12.2-.11.26,0,.06.05.16.18.2l2.9.83h0c.63.18,1.11.66,1.28,1.28l.83,2.9c.04.13.14.17.2.18.06.01.18.01.26-.11l1.94-2.69c.34-.48.9-.77,1.49-.78l3.27-.05c.14,0,.21-.09.23-.15.03-.05.06-.16-.02-.27l-1.82-2.49c-.37-.51-.46-1.16-.25-1.75l1.07-2.96c.05-.13-.02-.23-.06-.27-.04-.04-.14-.11-.27-.06l-2.96,1.07c-.59.21-1.24.12-1.74-.25l-2.48-1.82c-.05-.04-.11-.05-.15-.05Z"
      />
    </svg>
  );
}

function RhHsMembership({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      viewBox="0 0 43 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_49)">
        <path
          d="M21.92 5.29001H13.1V6.79001H21.92V5.29001Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path d="M28.98 10.59H6.03999V12.09H28.98V10.59Z" className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path d="M28.98 15.88H6.03999V17.38H28.98V15.88Z" className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path d="M28.98 21.17H6.03999V22.67H28.98V21.17Z" className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path d="M11.33 28.23H6.03999V29.73H11.33V28.23Z" className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path d="M11.33 33.53H6.03999V35.03H11.33V33.53Z" className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path
          d="M21.92 39.44C21.36 39.44 20.94 39.1 20.63 38.85C20.52 38.76 20.35 38.63 20.28 38.61C20.21 38.59 19.98 38.62 19.83 38.65C19.42 38.71 18.92 38.79 18.45 38.52C17.97 38.25 17.79 37.77 17.64 37.38C17.59 37.24 17.51 37.04 17.46 36.98C17.41 36.93 17.2 36.85 17.06 36.8C16.67 36.65 16.19 36.46 15.92 35.99C15.65 35.52 15.72 35.01 15.79 34.61C15.81 34.46 15.85 34.23 15.83 34.16C15.81 34.09 15.67 33.93 15.59 33.82C15.34 33.51 15 33.09 15 32.53C15 31.97 15.34 31.55 15.59 31.24C15.68 31.13 15.81 30.96 15.83 30.9C15.85 30.83 15.82 30.6 15.79 30.45C15.73 30.04 15.65 29.54 15.92 29.07C16.2 28.6 16.67 28.41 17.06 28.26C17.2 28.21 17.4 28.13 17.46 28.08C17.51 28.03 17.59 27.82 17.64 27.68C17.79 27.29 17.98 26.81 18.45 26.54C18.92 26.27 19.43 26.35 19.83 26.41C19.98 26.43 20.21 26.47 20.28 26.45C20.35 26.43 20.51 26.29 20.62 26.21C20.93 25.96 21.35 25.62 21.91 25.62C22.47 25.62 22.89 25.96 23.2 26.21C23.31 26.3 23.48 26.43 23.54 26.46C23.61 26.47 23.84 26.44 23.99 26.42C24.39 26.36 24.9 26.28 25.37 26.55C25.84 26.83 26.03 27.3 26.18 27.69C26.23 27.83 26.31 28.03 26.36 28.09C26.41 28.14 26.62 28.22 26.76 28.27C27.15 28.42 27.63 28.61 27.9 29.08C28.17 29.55 28.1 30.06 28.03 30.46C28.01 30.6 27.97 30.84 27.99 30.91C28.01 30.98 28.15 31.14 28.23 31.25C28.48 31.56 28.82 31.98 28.82 32.54C28.82 33.1 28.48 33.52 28.23 33.83C28.14 33.94 28.01 34.11 27.98 34.17C27.96 34.24 28 34.48 28.02 34.62C28.08 35.03 28.16 35.53 27.89 36C27.61 36.48 27.14 36.66 26.75 36.81C26.61 36.86 26.41 36.94 26.35 36.99C26.3 37.04 26.22 37.25 26.17 37.39C26.02 37.78 25.83 38.26 25.36 38.53C24.89 38.8 24.38 38.73 23.98 38.66C23.83 38.64 23.61 38.61 23.53 38.62C23.46 38.64 23.3 38.78 23.19 38.86C22.88 39.11 22.46 39.45 21.9 39.45L21.92 39.44ZM20.22 37.1C20.37 37.1 20.52 37.11 20.67 37.16C21.04 37.26 21.32 37.48 21.57 37.68C21.67 37.76 21.84 37.89 21.92 37.93C22 37.89 22.17 37.76 22.27 37.68C22.52 37.48 22.8 37.25 23.16 37.16C23.54 37.06 23.9 37.12 24.22 37.16C24.36 37.18 24.58 37.22 24.66 37.2C24.66 37.18 24.74 36.97 24.8 36.83C24.92 36.53 25.05 36.19 25.32 35.92C25.59 35.65 25.93 35.52 26.23 35.4C26.37 35.35 26.58 35.26 26.63 35.21C26.62 35.19 26.59 34.97 26.56 34.83C26.51 34.51 26.46 34.14 26.56 33.77C26.66 33.4 26.88 33.12 27.08 32.87C27.17 32.76 27.32 32.57 27.34 32.5C27.32 32.47 27.17 32.28 27.08 32.17C26.88 31.92 26.65 31.64 26.56 31.28C26.46 30.9 26.52 30.54 26.56 30.22C26.58 30.07 26.62 29.86 26.6 29.78C26.58 29.78 26.37 29.7 26.23 29.64C25.93 29.52 25.59 29.39 25.32 29.12C25.05 28.85 24.92 28.51 24.8 28.21C24.75 28.07 24.66 27.86 24.61 27.81C24.59 27.82 24.37 27.85 24.23 27.88C23.91 27.93 23.54 27.98 23.17 27.88C22.8 27.78 22.52 27.56 22.27 27.36C22.16 27.27 21.97 27.12 21.9 27.1C21.87 27.12 21.68 27.27 21.57 27.36C21.32 27.56 21.04 27.78 20.68 27.88C20.3 27.98 19.94 27.93 19.62 27.88C19.48 27.86 19.26 27.83 19.19 27.84C19.19 27.86 19.11 28.07 19.05 28.21C18.93 28.51 18.8 28.85 18.53 29.12C18.26 29.39 17.92 29.52 17.62 29.64C17.48 29.69 17.27 29.78 17.22 29.83C17.23 29.85 17.26 30.07 17.29 30.21C17.34 30.53 17.39 30.89 17.29 31.27C17.19 31.64 16.97 31.92 16.77 32.17C16.68 32.28 16.53 32.47 16.51 32.54C16.53 32.57 16.68 32.76 16.77 32.87C16.97 33.12 17.2 33.4 17.29 33.77C17.39 34.15 17.33 34.51 17.29 34.83C17.27 34.98 17.23 35.2 17.25 35.27C17.25 35.27 17.48 35.35 17.62 35.4C17.92 35.52 18.26 35.65 18.54 35.92C18.82 36.19 18.95 36.53 19.06 36.84C19.11 36.98 19.19 37.19 19.25 37.24C19.27 37.23 19.49 37.2 19.63 37.17C19.82 37.14 20.02 37.11 20.24 37.11L20.22 37.1Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M18.4 45.61C18.26 45.61 18.13 45.57 18.01 45.5C17.79 45.36 17.65 45.12 17.65 44.86V37.22H19.15V43.65L21.59 42.43C21.8 42.32 22.05 42.32 22.26 42.43L24.7 43.65V37.22H26.2V44.86C26.2 45.12 26.07 45.36 25.84 45.5C25.62 45.64 25.34 45.65 25.11 45.53L21.92 43.93L18.73 45.53C18.62 45.58 18.51 45.61 18.39 45.61H18.4Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M39.57 12.09H34.28V10.59H39.57C40.13 10.59 40.58 10.13 40.58 9.58V4.29C40.58 2.76 39.33 1.51 37.8 1.51V0C40.16 0 42.08 1.92 42.08 4.28V9.57C42.08 10.96 40.95 12.08 39.57 12.08V12.09Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M32.51 42.08H25.45V40.58H32.51C33.07 40.58 33.52 40.12 33.52 39.57V4.28C33.52 3.22 33.91 2.25 34.55 1.5H5.16C3.14 1.5 1.5 3.14 1.5 5.16V39.57C1.5 40.13 1.96 40.58 2.51 40.58H18.39V42.08H2.51C1.12 42.08 0 40.95 0 39.57V5.16C0 2.32 2.32 0 5.16 0H37.8C38.21 0 38.55 0.34 38.55 0.75C38.55 1.16 38.21 1.5 37.8 1.5C36.27 1.5 35.02 2.75 35.02 4.28V39.57C35.02 40.96 33.89 42.08 32.51 42.08Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
      </g>
    </svg>
  );
}

function WorkWithUs({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      viewBox="0 0 49 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M28.83 33.09V31.59C30.35 31.59 31.59 30.35 31.59 28.83V20.05C31.59 19.04 30.95 18.15 29.99 17.83L28.18 17.37L24.97 20.58C24.83 20.72 24.64 20.8 24.44 20.8C24.24 20.8 24.05 20.72 23.91 20.58L20.7 17.37L18.84 17.84C17.93 18.14 17.29 19.03 17.29 20.04V28.82C17.29 30.34 18.53 31.58 20.05 31.58V33.08C17.7 33.08 15.79 31.17 15.79 28.82V20.04C15.79 18.38 16.85 16.92 18.42 16.4L20.74 15.81C21 15.75 21.27 15.81 21.46 16.01L24.44 18.99L27.42 16.01C27.61 15.82 27.88 15.75 28.14 15.81L30.41 16.39C32.03 16.93 33.09 18.39 33.09 20.05V28.83C33.09 31.18 31.18 33.09 28.83 33.09Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M24.44 15.54C22.09 15.54 20.18 13.63 20.18 11.28C20.18 8.93 22.09 7.02 24.44 7.02C26.79 7.02 28.7 8.93 28.7 11.28C28.7 13.63 26.79 15.54 24.44 15.54ZM24.44 8.52C22.92 8.52 21.68 9.76 21.68 11.28C21.68 12.8 22.92 14.04 24.44 14.04C25.96 14.04 27.2 12.8 27.2 11.28C27.2 9.76 25.96 8.52 24.44 8.52Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M28.83 45.38H20.05C19.64 45.38 19.3 45.04 19.3 44.63V21.81H20.8V43.88H28.08V21.81H29.58V44.63C29.58 45.04 29.24 45.38 28.83 45.38Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path d="M25.19 30.59H23.69V44.63H25.19V30.59Z" className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
        <path
          d="M13.04 33.09V31.59C14.56 31.59 15.8 30.35 15.8 28.83V20.05C15.8 19.04 15.16 18.15 14.2 17.83L12.39 17.37L9.18 20.58C8.9 20.86 8.4 20.86 8.12 20.58L4.91 17.37L3.05 17.84C2.14 18.14 1.5 19.03 1.5 20.04V28.82C1.5 30.34 2.74 31.58 4.26 31.58V33.08C1.91 33.08 0 31.17 0 28.82V20.04C0 18.38 1.06 16.92 2.63 16.4L4.95 15.81C5.21 15.75 5.48 15.81 5.67 16.01L8.65 18.99L11.63 16.01C11.82 15.82 12.09 15.75 12.35 15.81L14.63 16.39C16.25 16.93 17.31 18.39 17.31 20.05V28.83C17.31 31.18 15.4 33.09 13.05 33.09H13.04Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M8.65001 15.54C6.30001 15.54 4.39001 13.63 4.39001 11.28C4.39001 8.93 6.30001 7.02 8.65001 7.02C11 7.02 12.91 8.93 12.91 11.28C12.91 13.63 11 15.54 8.65001 15.54ZM8.65001 8.52C7.13001 8.52 5.89001 9.76 5.89001 11.28C5.89001 12.8 7.13001 14.04 8.65001 14.04C10.17 14.04 11.41 12.8 11.41 11.28C11.41 9.76 10.17 8.52 8.65001 8.52Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M16.55 8.52C14.2 8.52 12.29 6.61 12.29 4.26C12.29 1.91 14.2 0 16.55 0C18.9 0 20.81 1.91 20.81 4.26C20.81 6.61 18.9 8.52 16.55 8.52ZM16.55 1.5C15.03 1.5 13.79 2.74 13.79 4.26C13.79 5.78 15.03 7.02 16.55 7.02C18.07 7.02 19.31 5.78 19.31 4.26C19.31 2.74 18.07 1.5 16.55 1.5Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M32.34 8.52C29.99 8.52 28.08 6.61 28.08 4.26C28.08 1.91 29.99 0 32.34 0C34.69 0 36.6 1.91 36.6 4.26C36.6 6.61 34.69 8.52 32.34 8.52ZM32.34 1.5C30.82 1.5 29.58 2.74 29.58 4.26C29.58 5.78 30.82 7.02 32.34 7.02C33.86 7.02 35.1 5.78 35.1 4.26C35.1 2.74 33.86 1.5 32.34 1.5Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M13.04 45.38H4.26001C3.85001 45.38 3.51001 45.04 3.51001 44.63V21.81H5.01001V43.88H12.29V21.81H13.79V44.63C13.79 45.04 13.45 45.38 13.04 45.38Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M9.39999 30.59H7.89999V44.63H9.39999V30.59Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M44.63 33.09V31.59C46.15 31.59 47.39 30.35 47.39 28.83V20.05C47.39 19.04 46.75 18.15 45.79 17.83L43.98 17.37L40.77 20.58C40.63 20.72 40.44 20.8 40.24 20.8C40.04 20.8 39.85 20.72 39.71 20.58L36.5 17.37L34.64 17.84C33.73 18.14 33.09 19.03 33.09 20.04V28.82C33.09 30.34 34.33 31.58 35.85 31.58V33.08C33.5 33.08 31.59 31.17 31.59 28.82V20.04C31.59 18.38 32.65 16.92 34.22 16.4L36.54 15.81C36.8 15.75 37.07 15.81 37.26 16.01L40.24 18.99L43.22 16.01C43.41 15.82 43.68 15.75 43.94 15.81L46.21 16.39C47.83 16.93 48.89 18.39 48.89 20.05V28.83C48.89 31.18 46.98 33.09 44.63 33.09Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M40.24 15.54C37.89 15.54 35.98 13.63 35.98 11.28C35.98 8.93 37.89 7.02 40.24 7.02C42.59 7.02 44.5 8.93 44.5 11.28C44.5 13.63 42.59 15.54 40.24 15.54ZM40.24 8.52C38.72 8.52 37.48 9.76 37.48 11.28C37.48 12.8 38.72 14.04 40.24 14.04C41.76 14.04 43 12.8 43 11.28C43 9.76 41.76 8.52 40.24 8.52Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path
          d="M44.63 45.38H35.85C35.44 45.38 35.1 45.04 35.1 44.63V21.81H36.6V43.88H43.88V21.81H45.38V44.63C45.38 45.04 45.04 45.38 44.63 45.38Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        />
        <path d="M40.99 30.59H39.49V44.63H40.99V30.59Z" className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth} />
      </g>
    </svg>
  );
}

function CompInfo({ className, strokeWidth }) {
  return (
    <svg
      id="uuid-4585c260-0a48-4278-8b6f-decdfb04fdbb"
      data-name="Layer 1"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 53.62 42.04"
    >
      <rect
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        x="26.06"
        y="27.77"
        width="1.5"
        height="13.51"
      />
      <rect
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        x="26.06"
        y="4.61"
        width="1.5"
        height="1.93"
      />
      <path
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        d="M26.81,28.52c-6.27,0-11.37-5.1-11.37-11.37s5.1-11.37,11.37-11.37,11.37,5.1,11.37,11.37-5.1,11.37-11.37,11.37ZM26.81,7.29c-5.44,0-9.87,4.43-9.87,9.87s4.43,9.87,9.87,9.87,9.87-4.43,9.87-9.87-4.43-9.87-9.87-9.87Z"
      />
      <path
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        d="M40.49,34.32c-.93,0-1.8-.36-2.46-1.02l-6.43-6.43,1.06-1.06,6.43,6.43c.75.75,2.05.75,2.8,0,.77-.77.77-2.03,0-2.8l-6.43-6.43,1.06-1.06,6.43,6.43c1.36,1.36,1.36,3.56,0,4.92-.66.66-1.53,1.02-2.46,1.02Z"
      />
      <path
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        d="M27.56,21.02h-1.5v-.97c0-1.43,1.13-2.36,2.03-3.1l.08-.07c.5-.41.78-1.01.78-1.66,0-1.18-.96-2.15-2.15-2.15s-2.15.96-2.15,2.15h-1.5c0-2.01,1.64-3.65,3.65-3.65s3.65,1.64,3.65,3.65c0,1.09-.48,2.12-1.33,2.81l-.08.07c-.73.6-1.49,1.22-1.49,1.94v.97Z"
      />
      <path
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        d="M26.81,42.04c-.28,0-.54-.16-.67-.41-1.05-2.09-3.24-3.45-5.58-3.45H4.61c-.41,0-.75-.34-.75-.75V.75c0-.41.34-.75.75-.75h15.95c2.47,0,4.8,1.22,6.25,3.18,1.44-1.96,3.78-3.18,6.25-3.18h15.95c.41,0,.75.34.75.75v36.68c0,.41-.34.75-.75.75h-15.95c-2.34,0-4.53,1.35-5.58,3.45-.13.25-.39.42-.67.42ZM5.36,36.68h15.2c2.47,0,4.8,1.22,6.25,3.18,1.44-1.96,3.78-3.18,6.25-3.18h15.2V1.5h-15.2c-2.34,0-4.53,1.35-5.58,3.45-.25.51-1.09.51-1.34,0-1.05-2.09-3.24-3.45-5.58-3.45H5.36v35.18Z"
      />
      <path
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        d="M52.87,42.04H.75c-.41,0-.75-.34-.75-.75V4.61c0-.41.34-.75.75-.75h3.86v1.5H1.5v35.18h50.62V5.36h-3.11v-1.5h3.86c.41,0,.75.34.75.75v36.68c0,.41-.34.75-.75.75Z"
      />
    </svg>
  );
}

function AboutTheShow({ className, strokeWidth }) {
  return (
    <svg
      id="uuid-d004ed59-ff4a-4a76-854c-6a3d8804b5a3"
      data-name="Layer 1"
      className={className}
      strokeWidth={strokeWidth}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 45.61 45.61"
    >
      <path
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        d="M17.32,23.14h-.02l-16.57-.47c-.22,0-.43-.11-.57-.29-.14-.18-.19-.41-.14-.62l1.73-7.71c.05-.22.19-.4.39-.5s.43-.11.64-.02l15.2,6.65c.36.16.54.57.41.94l-.05.14c-.13.36-.21.72-.25,1.07h0s-.02.15-.02.15c-.04.38-.36.67-.75.67ZM1.68,21.19l14.99.43c.02-.12.05-.23.08-.35L3.01,15.26l-1.33,5.93Z"
      />
      <path
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        d="M21.92,45.61c-.05,0-.11,0-.16-.02l-7.71-1.73c-.22-.05-.4-.19-.5-.39-.1-.2-.11-.43-.02-.64l6.67-15.25c.15-.35.55-.53.92-.41l.14.04h0c.34.11.7.19,1.05.22h.15c.4.05.7.38.69.78l-.47,16.67c0,.22-.11.43-.29.57-.13.1-.3.16-.46.16ZM15.26,42.61l5.93,1.33.43-15.08c-.11-.02-.21-.04-.32-.07l-6.04,13.82Z"
      />
      <path
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        d="M43.14,32.16c-.1,0-.2-.02-.3-.06l-15.38-6.73c-.36-.16-.53-.56-.41-.93l.05-.14c.12-.34.19-.69.23-1.01l.02-.15c.04-.38.36-.67.75-.67h.02l16.78.48c.22,0,.43.11.57.29.14.18.19.41.14.62l-1.73,7.71c-.05.22-.19.4-.39.5-.11.05-.22.08-.34.08ZM28.67,24.26l13.94,6.09,1.33-5.93-15.2-.43c-.02.09-.04.18-.06.27Z"
      />
      <path
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        d="M24.71,18.55c-.09,0-.17-.01-.26-.05l-.14-.05c-.34-.12-.69-.21-1.03-.25l-.15-.02c-.38-.05-.67-.38-.65-.77l.48-16.69c0-.22.11-.43.29-.57s.4-.19.62-.14l7.71,1.73c.22.05.4.19.5.39.1.2.11.43.02.64l-6.7,15.33c-.12.28-.4.45-.69.45ZM23.99,16.8c.1.02.2.05.3.07l6.06-13.87-5.93-1.33-.43,15.12Z"
      />

      <path
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        d="M6.58,38.52s-.06,0-.09,0c-.22-.03-.42-.15-.54-.34l-4.23-6.67c-.12-.19-.15-.42-.08-.63s.23-.38.44-.46l15.45-6.05c.36-.14.77.01.94.36l.07.13s0,0,0,0c.17.34.37.65.59.92l.1.12c.25.3.23.75-.06,1.02l-12.07,11.4c-.14.13-.32.21-.51.21ZM3.47,31.47l3.26,5.13,10.92-10.31c-.07-.1-.13-.2-.19-.3l-13.98,5.47Z"
      />
      <path
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        d="M27.64,21.38c-.28,0-.55-.16-.68-.43l-.06-.13s0,0,0,0c-.15-.32-.34-.62-.55-.89l-.09-.11c-.24-.3-.21-.74.07-1.01l12.19-11.51c.16-.15.39-.23.61-.2.22.03.42.15.54.34l4.23,6.67c.12.19.15.42.08.63s-.23.38-.44.46l-15.63,6.12c-.09.04-.18.05-.27.05ZM27.84,19.45c.05.08.1.16.15.24l14.16-5.54-3.26-5.14-11.05,10.44Z"
      />
      <path
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        d="M31.1,44.02c-.08,0-.16-.01-.23-.04-.21-.07-.38-.23-.46-.44l-6.1-15.58c-.14-.36.02-.77.36-.94l.13-.06c.32-.16.62-.36.88-.57l.12-.1c.3-.25.75-.23,1.02.06l11.5,12.18c.15.16.23.39.2.61-.03.22-.15.42-.34.54l-6.67,4.23c-.12.08-.26.12-.4.12ZM25.94,28.03l5.53,14.12,5.14-3.26-10.42-11.03c-.08.06-.16.11-.25.16Z"
      />
      <path
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        d="M19.25,19.41c-.2,0-.4-.08-.54-.24L7.3,7.09c-.15-.16-.23-.39-.2-.61.03-.22.15-.42.34-.54L14.11,1.72c.19-.12.42-.15.63-.08.21.07.38.23.46.44l6.07,15.5c.14.37-.02.79-.38.95l-.14.06c-.33.15-.65.34-.93.57l-.11.09c-.14.11-.3.16-.46.16ZM9.01,6.73l10.33,10.94c.09-.06.19-.12.29-.18L14.15,3.47l-5.14,3.26Z"
      />
    </svg>
  );
}

function Accessibility({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="43"
      height="38"
      viewBox="0 0 43 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.21 15C34.55 6.76999 27.27 0.549988 18.55 0.549988C8.62 0.549988 0.550003 8.61999 0.550003 18.55C0.550003 28.48 8.62 36.55 18.55 36.55C23.24 36.55 27.51 34.75 30.72 31.8M28.08 12.64C28.68 12.53 29.17 12.01 29.15 11.39C29.13 10.6 28.43 10.05 27.69 10.19L22.25 11.2C21.03 11.43 19.79 11.54 18.55 11.54C17.31 11.54 16.07 11.43 14.85 11.2L9.47 10.2C8.86 10.09 8.23 10.4 8.02 10.98C7.75 11.72 8.22 12.49 8.95 12.62L15.45 13.83L15.54 17.15C15.6 19.3 15.36 21.44 14.84 23.52L13.21 30.02C13.04 30.69 13.34 31.42 13.97 31.69C14.77 32.04 15.65 31.57 15.85 30.76L18.22 21.3C18.3 20.97 18.77 20.97 18.85 21.3L21.22 30.76C21.38 31.38 21.94 31.8 22.55 31.8C22.76 31.8 22.97 31.75 23.18 31.65C23.76 31.36 24.03 30.67 23.87 30.04L22.24 23.52C21.72 21.44 21.48 19.29 21.54 17.15L21.63 13.83L28.07 12.63L28.08 12.64ZM21.2975 7.91014C21.3696 9.42721 20.1982 10.7155 18.6811 10.7875C17.1641 10.8596 15.8758 9.68821 15.8037 8.17114C15.7317 6.65407 16.9031 5.36581 18.4201 5.29374C19.9372 5.22166 21.2255 6.39306 21.2975 7.91014ZM41.72 20.47L33.31 28.88C32.84 29.35 32.3 29.58 31.67 29.58C31.04 29.58 30.5 29.35 30.03 28.88L25.82 24.67C24.96 23.74 24.96 22.33 25.82 21.4C26.68 20.54 28.16 20.54 29.09 21.4L31.66 23.97L38.44 17.19C39.3 16.33 40.78 16.33 41.71 17.19C42.57 18.13 42.57 19.61 41.71 20.46L41.72 20.47Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}

function Rides({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="38"
      height="37"
      viewBox="0 0 38 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2 6.86999L17.55 9.72999M19.78 4.51999L24.28 8.17999M5.42 15.57L7.92 20.8M33.27 7.44999L28.49 4.26999L26.66 1.75999C24.41 -1.10001 16.87 1.07999 9.83 6.61999C2.78 12.17 -1.11 18.98 1.14 21.84L2.63 23.92L4.38 28.87M9.41 25.14L11.6 31.93M15 22.72L18.57 30.05M23.56 16.12L29.8 21.26M27.51 11.22L33.57 15.06M8.79 11.75L11.14 14.6M16.2 18.03L18.25 20.63C17.16 21.42 16.08 22.1 15 22.71C13.03 23.83 11.12 24.65 9.41 25.13C6.43 25.94 4.07 25.76 2.96 24.35C0.719996 21.5 4.60999 14.67 11.66 9.12999C18.7 3.58999 26.23 1.41999 28.48 4.26999C30.29 6.57999 28.13 11.41 23.56 16.11C22.89 16.8 22.19 17.47 21.41 18.13L19.37 15.54M16.2 18.03L16.28 17.97M16.2 18.03L16.2 18.04L30.09 36.22L34.6 35.97L19.37 15.54M16.28 17.97C16.19 17.93 16.11 17.89 16.05 17.81M16.28 17.97C16.19 17.94 16.11 17.89 16.05 17.81M16.05 17.81C15.74 17.41 16.2 16.52 17.08 15.83M16.05 17.81C15.73 17.41 16.2 16.52 17.08 15.83M17.08 15.83C17.96 15.14 18.92 14.9 19.23 15.3M17.08 15.83C17.96 15.14 18.91 14.9 19.23 15.3M19.23 15.3C19.29 15.38 19.32 15.47 19.32 15.58M19.23 15.3C19.3 15.38 19.32 15.47 19.32 15.58M19.32 15.58L19.37 15.54M20.6106 10.6819L17.725 13.0454C17.5157 13.2169 17.2069 13.1862 17.0355 12.9768L15.9646 11.6694C15.7931 11.4601 15.8238 11.1513 16.0332 10.9799L18.9188 8.61634C19.1281 8.44486 19.4368 8.47557 19.6083 8.68493L20.6792 9.99234C20.8507 10.2017 20.82 10.5104 20.6106 10.6819ZM27.4536 8.56115L25.05 11.4135C24.8756 11.6204 24.5665 11.6468 24.3596 11.4724L23.0672 10.3834C22.8603 10.209 22.8339 9.89988 23.0083 9.69294L25.4119 6.84062C25.5862 6.63368 25.8954 6.60729 26.1023 6.78167L27.3947 7.87069C27.6016 8.04508 27.628 8.3542 27.4536 8.56115ZM6.33607 21.5892L9.6733 19.9232C9.91543 19.8023 10.2097 19.9006 10.3306 20.1427L11.0854 21.6548C11.2063 21.8969 11.108 22.1911 10.8659 22.312L7.52867 23.9781C7.28655 24.099 6.99228 24.0007 6.8714 23.7586L6.11653 22.2465C5.99566 22.0044 6.09395 21.7101 6.33607 21.5892ZM36.4763 7.53504L34.355 10.6031C34.2011 10.8257 33.8959 10.8814 33.6733 10.7275L32.2832 9.76639C32.0606 9.61248 32.0049 9.30727 32.1588 9.08467L34.2801 6.0166C34.434 5.794 34.7392 5.73831 34.9618 5.89222L36.3519 6.85333C36.5745 7.00723 36.6302 7.31244 36.4763 7.53504ZM2.72927 29.5069L6.20989 28.166C6.46241 28.0687 6.74599 28.1945 6.84328 28.4471L7.45085 30.0241C7.54814 30.2766 7.4223 30.5602 7.16977 30.6575L3.68915 31.9984C3.43663 32.0957 3.15305 31.9699 3.05576 31.7173L2.44819 30.1403C2.3509 29.8878 2.47674 29.6042 2.72927 29.5069ZM9.95665 32.5667L13.4373 31.2257C13.6898 31.1285 13.9734 31.2543 14.0707 31.5068L14.6782 33.0838C14.7755 33.3364 14.6497 33.6199 14.3972 33.7172L10.9165 35.0582C10.664 35.1555 10.3804 35.0296 10.2831 34.7771L9.67557 33.2001C9.57828 32.9476 9.70412 32.664 9.95665 32.5667ZM17.0476 30.9342L20.2687 29.0535C20.5024 28.917 20.8025 28.9958 20.9389 29.2295L21.7911 30.689C21.9275 30.9227 21.8487 31.2227 21.615 31.3592L18.3939 33.24C18.1602 33.3764 17.8601 33.2976 17.7236 33.0639L16.8715 31.6044C16.735 31.3707 16.8139 31.0707 17.0476 30.9342ZM32.9472 21.8456L30.3618 24.5342C30.1742 24.7292 29.864 24.7353 29.6689 24.5477L28.4508 23.3763C28.2557 23.1887 28.2497 22.8785 28.4372 22.6835L31.0227 19.9949C31.2103 19.7998 31.5205 19.7938 31.7155 19.9814L32.9337 21.1528C33.1287 21.3404 33.1348 21.6506 32.9472 21.8456ZM36.7662 15.134L34.6449 18.202C34.491 18.4246 34.1858 18.4803 33.9632 18.3264L32.5731 17.3653C32.3505 17.2114 32.2948 16.9062 32.4487 16.6836L34.57 13.6155C34.7239 13.3929 35.0291 13.3372 35.2517 13.4911L36.6418 14.4522C36.8644 14.6061 36.9201 14.9114 36.7662 15.134ZM14.195 15.5486L11.3094 17.9121C11.1001 18.0836 10.7913 18.0529 10.6199 17.8435L9.549 16.5361C9.37752 16.3268 9.40823 16.018 9.61758 15.8466L12.5032 13.483C12.7125 13.3116 13.0213 13.3423 13.1927 13.5516L14.2636 14.859C14.4351 15.0684 14.4044 15.3771 14.195 15.5486Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
    </svg>
  );
}

function Parking({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="28"
      height="36"
      viewBox="0 0 28 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.64 3.37C21.62 1.62 18.91 0.75 15.51 0.75H0.75V34.62H7.78V22.44H14.97C18.72 22.44 21.61 21.61 23.63 19.96C25.65 18.31 26.66 15.48 26.66 11.48C26.66 7.82 25.65 5.11 23.63 3.37H23.64ZM18.28 15.39C17.35 16.2 16.04 16.61 14.37 16.61H7.77V6.63H14.37C16.04 6.63 17.34 7.01 18.27 7.76C19.2 8.51 19.66 9.77 19.66 11.53C19.66 13.29 19.2 14.58 18.28 15.39Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
    </svg>
  );
}

function Map({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="32"
      height="38"
      viewBox="0 0 32 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.91 11.15L2.10999 8.93C1.75999 8.84 1.38999 8.92 1.09999 9.14C0.809994 9.36 0.649994 9.7 0.649994 10.07V33.12C0.649994 33.66 1.00999 34.13 1.52999 34.26L10.76 36.61C10.86 36.63 10.95 36.65 11.05 36.65C11.14 36.65 11.24 36.64 11.34 36.61L20.28 34.33L29.22 36.61C29.32 36.63 29.41 36.65 29.51 36.65C29.77 36.65 30.02 36.56 30.23 36.4C30.52 36.18 30.68 35.84 30.68 35.47V12.42C30.68 11.88 30.32 11.41 29.8 11.28L28.43 10.93M10.91 14.15V34.15M19.91 23.15V32.15M14.28 10.46L19.77 20.37C19.87 20.56 20.07 20.67 20.28 20.67C20.49 20.67 20.69 20.55 20.79 20.37L26.28 10.46C26.28 10.46 26.31 10.4 26.32 10.38C26.78 9.44 27.02 8.44 27.02 7.4C27.02 3.68 23.99 0.660004 20.28 0.660004C16.57 0.660004 13.54 3.69 13.54 7.4C13.54 8.44 13.78 9.44 14.24 10.38C14.25 10.41 14.26 10.44 14.28 10.47V10.46ZM20.29 4.95C21.59 4.95 22.64 6 22.64 7.3C22.64 8.6 21.59 9.65 20.29 9.65C18.99 9.65 17.94 8.6 17.94 7.3C17.94 6 18.99 4.95 20.29 4.95Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function Safety({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="42"
      height="37"
      viewBox="0 0 42 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.74 35.64H38.69C40.08 35.64 40.94 34.14 40.25 32.94L22.17 1.65C21.48 0.45 19.75 0.45 19.06 1.65L0.990006 32.94C0.300006 34.14 1.16001 35.64 2.55001 35.64H14.5M20.62 26.9C19.45 26.9 18.47 26.03 18.32 24.87L17.06 14.99C16.86 13.46 17.67 11.97 19.06 11.3C20.05 10.82 21.21 10.82 22.2 11.3C23.59 11.97 24.4 13.46 24.2 14.99L22.94 24.87C22.79 26.03 21.81 26.9 20.64 26.9H20.62ZM23.42 32.95C23.42 34.4964 22.1664 35.75 20.62 35.75C19.0736 35.75 17.82 34.4964 17.82 32.95C17.82 31.4036 19.0736 30.15 20.62 30.15C22.1664 30.15 23.42 31.4036 23.42 32.95Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
    </svg>
  );
}

export function GettingHere({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="25"
      height="37"
      viewBox="0 0 25 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.46 0.75C6.01 0.75 0.75 6.01 0.75 12.46C0.75 14.27 1.16 16.01 1.97 17.64C1.99 17.69 2.01 17.73 2.03 17.77L11.76 35.32C11.9 35.58 12.17 35.74 12.47 35.74C12.77 35.74 13.03 35.58 13.18 35.32L22.91 17.77C22.91 17.77 22.95 17.68 22.97 17.64C23.78 16.01 24.19 14.26 24.19 12.45C24.18 6.01 18.92 0.75 12.46 0.75ZM16.13 18.59L12.46 16.66L8.79 18.59L9.49 14.5L6.52 11.61L10.62 11.01L12.45 7.29L14.28 11.01L18.38 11.61L15.41 14.5L16.11 18.59H16.13Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
    </svg>
  );
}

export function Clock({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="38"
      height="39"
      viewBox="0 0 38 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.6 19.54H6.44M18.54 34.49V31.64M30.64 19.54H33.49M11.07 6.6L12.49 9.06M24.59 30.02L26.02 32.49M5.6 12.07L8.06 13.49M29.02 25.59L31.49 27.02M18.54 20.97V23.1M18.54 4.6V18.12M18.54 18.12C17.7558 18.12 17.12 18.7558 17.12 19.54C17.12 20.3242 17.7558 20.96 18.54 20.96C19.3242 20.96 19.96 20.3242 19.96 19.54C19.96 18.7558 19.3242 18.12 18.54 18.12ZM25.66 23.65L19.77 20.25M17.32 18.83L15.7 17.9M8.99 29.09L11.49 26.59L1.42 24.58L3.43 34.65L5.96 32.12C9.18 35.34 13.62 37.34 18.53 37.34C28.36 37.34 36.32 29.37 36.32 19.55C36.32 19.37 36.32 19.19 36.31 19.01M28.1 9.98L25.59 12.49L35.66 14.5L33.65 4.43L31.13 6.95C27.91 3.73 23.47 1.73 18.55 1.73C8.72 1.75 0.75 9.72 0.75 19.54C0.75 19.72 0.75 19.9 0.76 20.08"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
    </svg>
  );
}

export function DramaMasks({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="37"
      height="40"
      viewBox="0 0 37 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.42 9.64001L24.05 19.39M15.12 13.99L2.67999 21.91C2.03999 22.31 1.83999 23.15 2.21999 23.8L3.68999 26.34C4.06999 26.99 4.88999 27.23 5.55999 26.88L18.64 20.07M25.98 35.1V22.43H35.84V33.69M25.98 35.1C25.98 36.6519 24.7219 37.91 23.17 37.91C21.6181 37.91 20.36 36.6519 20.36 35.1C20.36 33.5481 21.6181 32.29 23.17 32.29C24.7219 32.29 25.98 33.5481 25.98 35.1ZM25.98 26.66H35.84M2.97999 25.11L2.52999 25.41C1.35999 26.19 0.649994 27.51 0.649994 28.92V30.88M13.32 22.84V39.32M27.32 16.14C26.74 18.29 21.76 21.17 19.61 20.59C17.46 20.01 14.58 15.03 15.16 12.88C15.74 10.73 20.72 7.85001 22.87 8.43001C25.02 9.01001 27.9 13.99 27.32 16.14ZM35.83 33.69C35.83 35.2419 34.5719 36.5 33.02 36.5C31.4681 36.5 30.21 35.2419 30.21 33.69C30.21 32.1381 31.4681 30.88 33.02 30.88C34.5719 30.88 35.83 32.1381 35.83 33.69ZM31.61 4.14001C31.61 6.09001 29.34 8.36001 27.39 8.36001C29.34 8.36001 31.61 10.63 31.61 12.58C31.61 10.63 33.88 8.36001 35.83 8.36001C33.88 8.36001 31.61 6.09001 31.61 4.14001ZM9.44999 9.41001L7.39999 12.81L5.93999 8.95001L2.05999 7.86001L5.12999 5.40001L4.77999 1.32001L8.13999 3.66001L11.81 2.23001L10.81 6.13001L13.43 9.33001L9.44999 9.41001Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
    </svg>
  );
}

export function Bag({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="32"
      height="38"
      viewBox="0 0 32 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.26 2.37999H30.47V33.19C30.47 35.1 28.92 36.65 27.01 36.65H4.11C2.2 36.65 0.650002 35.1 0.650002 33.19V2.37999H7.12M19.81 2.37999H11.57M24.26 0.649994V8.73999C24.26 11.86 21.73 14.39 18.61 14.39H13.34C12.36 14.39 11.57 13.6 11.57 12.62V0.649994H7.12V8.73999C7.12 11.86 9.65 14.39 12.77 14.39H18.04C19.02 14.39 19.81 13.6 19.81 12.62V0.649994H24.26Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
    </svg>
  );
}

export function Competition({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="41"
      height="29"
      viewBox="0 0 41 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40.28 6.39H40.78V5.89H40.28V6.39ZM40.28 28.5V29H40.78V28.5H40.28ZM6.39 28.5L6.03645 28.8536L6.18289 29H6.39V28.5ZM0.5 22.61H0V22.8171L0.146447 22.9636L0.5 22.61ZM0.5 0.5V0H0V0.5H0.5ZM34.39 0.5L34.7433 0.146147L34.5969 0H34.39V0.5ZM33.89 3.45C33.89 3.72614 34.1139 3.95 34.39 3.95C34.6661 3.95 34.89 3.72614 34.89 3.45H33.89ZM39.9367 6.74385C40.1322 6.93895 40.4488 6.93868 40.6439 6.74325C40.839 6.54783 40.8387 6.23124 40.6433 6.03615L39.9367 6.74385ZM6.39 13.76L6.03645 14.1136C6.13021 14.2073 6.25739 14.26 6.39 14.26V13.76ZM40.29 13.76V14.26C40.4923 14.26 40.6747 14.1381 40.752 13.9511C40.8294 13.7642 40.7864 13.549 40.6432 13.4061L40.29 13.76ZM6.39 6.89H40.28V5.89H6.39V6.89ZM39.78 6.39V28.5H40.78V6.39H39.78ZM40.28 28H6.39V29H40.28V28ZM6.89 28.5V6.39H5.89V28.5H6.89ZM1 22.61V7.87H0V22.61H1ZM1 7.87V0.5H0V7.87H1ZM0.5 1H34.39V0H0.5V1ZM33.89 0.5V3.45H34.89V0.5H33.89ZM6.74355 6.03645L0.853553 0.146447L0.146447 0.853553L6.03645 6.74355L6.74355 6.03645ZM34.0367 0.853853L39.9367 6.74385L40.6433 6.03615L34.7433 0.146147L34.0367 0.853853ZM0.146447 22.9636L6.03645 28.8536L6.74355 28.1464L0.853553 22.2564L0.146447 22.9636ZM4.18 7.37H0.5V8.37H4.18V7.37ZM0.146447 8.22355L6.03645 14.1136L6.74355 13.4064L0.853553 7.51645L0.146447 8.22355ZM6.39 14.26H40.29V13.26H6.39V14.26ZM40.6432 13.4061L35.4832 8.2561L34.7768 8.9639L39.9368 14.1139L40.6432 13.4061Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
    </svg>
  );
}

export function Animal({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="48"
      height="29"
      viewBox="0 0 48 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.95 21.9C27.33 23.24 32.28 22.04 34.2 21.15M34.2 21.15C33.19 20.13 33.01 19.46 33.01 18.49M34.2 21.15C35.21 22.17 37.95 23.65 37.95 23.65L36.95 27.65M41.45 27.65L43.65 22.83C42.01 19.27 44.95 18.37 44.95 11.65C44.94 2.62999 33.45 0.629989 28.73 0.649989C24.01 0.669989 17.81 0.649989 13.73 5.09999C10.97 7.87999 8.65 12.3 8.65 12.3C8.65 12.3 3.37 14.82 0.949997 17.65C3.24 19.32 6.9 19.65 6.9 19.65L8.91 18.56M7.15 9.24999L3.16 9.41999L4 11.68M5.14 22.13L4.63 23.68C5.39 24.82 6.32 25.71 7.54 26.2L14.22 24.36C14.92 24.22 15.54 23.81 15.94 23.22L16.58 22.29M23.95 27.65V21.29L23.52 17.93M17.45 18.49L19.37 20.97L20.23 23.46L20.95 27.65M44.08 7.71999C44.08 7.71999 46.95 7.01999 46.95 4.64999C46.95 2.80999 44.95 2.64999 44.95 2.64999"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function Education({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="29"
      height="39"
      viewBox="0 0 29 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.39 34.09H26.9C27.69 34.09 28.34 33.45 28.34 32.65M1 31.93V3.88C1 2.29 2.29 1 3.88 1H26.9C27.69 1 28.34 1.64 28.34 2.44V28.34C28.34 29.13 27.7 29.78 26.9 29.78H3.16C1.97 29.78 1 30.75 1 31.94C1 33.13 1.97 34.1 3.16 34.1H3.88M12.51 32.65V36.97L9.63 35.53L6.76 36.97V32.65M11.07 9.63H21.14M11.07 13.95H21.14M13.95 24.02H18.27M5.32 1V29.78"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function CommercialExhibitors({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="32"
      height="36"
      viewBox="0 0 32 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.32 36H28.13V33.89H31.45V0H0V33.89H3.32V36ZM4.33 34.99V23.53H27.12V34.99H4.33ZM27.12 22.52H4.33V19.39H27.12V22.52ZM18.08 15.73L18.88 18.38H12.56L13.36 15.73C13.44 15.46 13.29 15.18 13.02 15.1C12.75 15.02 12.47 15.17 12.39 15.44L11.51 18.34V18.38H9.89L11.45 13.86C11.57 13.44 11.8 13.08 12.14 12.81C12.48 12.55 12.94 12.37 13.55 12.37H17.85C18.47 12.37 18.94 12.54 19.28 12.8C19.62 13.06 19.85 13.41 19.96 13.83V13.85L21.53 18.38H19.92V18.34L19.03 15.44C18.95 15.17 18.67 15.02 18.4 15.1C18.13 15.18 17.98 15.46 18.06 15.73H18.08ZM1.01 32.88V1.01H30.43V32.87H28.12V18.37H22.6V18.31L20.93 13.53C20.76 12.93 20.42 12.38 19.9 11.98C19.37 11.58 18.67 11.35 17.86 11.35H13.56C12.75 11.35 12.05 11.59 11.53 12C11.01 12.4 10.67 12.95 10.49 13.53L8.84 18.31V18.37H3.32V32.87H1.01V32.88Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
      />
      <path
        d="M15.72 11.23C17.55 11.23 19.04 9.75 19.04 7.91C19.04 6.08 17.56 4.59 15.72 4.59C13.89 4.59 12.4 6.07 12.4 7.91C12.4 9.74 13.88 11.23 15.72 11.23ZM14.1 6.29C14.52 5.87 15.09 5.62 15.73 5.62C16.37 5.62 16.94 5.88 17.36 6.29C17.78 6.71 18.03 7.28 18.03 7.92C18.03 8.56 17.77 9.13 17.36 9.55C16.94 9.97 16.37 10.22 15.73 10.22C15.09 10.22 14.52 9.96 14.1 9.55C13.68 9.13 13.43 8.56 13.43 7.92C13.43 7.28 13.69 6.71 14.1 6.29Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}

export function GoyderPavilion({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="33"
      height="37"
      viewBox="0 0 33 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.18 26.57L25.53 36.51H0.529999L2.01 8.69H24.54L24.81 16.19M6.82 13.7H9.43M16.98 13.7H19.85M8.12 14.16V5.65C8.12 2.81 10.42 0.5 13.27 0.5C16.11 0.5 18.42 2.8 18.42 5.65V14.16M19.74 36.01C19.74 21.92 28.49 17.2 28.49 17.2M13.61 22.89C13.61 22.89 19.19 27.89 19.73 36.01M21.24 26.72C18.3 20.92 21.32 15.01 31.55 15.01C29.07 18.73 31.55 27.89 21.24 26.72ZM17.62 28.41C20.18 23.54 16.31 20.7 10.55 20.7C12.21 22.54 10.11 29.73 17.62 28.41Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function JubileePavilion({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="32"
      height="37"
      viewBox="0 0 32 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.18 23.5C27.18 25.16 25.83 26.51 24.17 26.51C22.51 26.51 21.16 25.16 21.16 23.5M18.62 36.01H0.519997L1.63 8.69H24.17L24.54 20.54M6.44 13.7H9.05M16.61 13.7H19.48M7.75 14.16V5.65C7.75 2.81 10.05 0.5 12.9 0.5C15.74 0.5 18.05 2.8 18.05 5.65V14.16M31.27 36.01H16.9L17.72 20.54H30.61L31.27 36.01Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function MarketBazaar({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="30"
      height="34"
      viewBox="0 0 30 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.11 0.5H4.6L4.25 2.17L0.5 4.08M29.11 0.5V29.88L25.83 31.28L25.02 33.46M29.11 0.5L24.35 2.53L25.02 4.08M25.02 33.46H0.5V4.08M25.02 33.46V4.08M0.5 4.08H25.02M8.28 10.1V13.98C8.28 16.56 10.4 18.65 13.02 18.65C15.64 18.65 17.76 16.56 17.76 13.98V10.1M9.62 8.77C9.62 9.51006 9.02006 10.11 8.28 10.11C7.53994 10.11 6.94 9.51006 6.94 8.77C6.94 8.02994 7.53994 7.43 8.28 7.43C9.02006 7.43 9.62 8.02994 9.62 8.77ZM19.08 8.77C19.08 9.51 18.48 10.11 17.74 10.11C17 10.11 16.4 9.51 16.4 8.77C16.4 8.03 17 7.43 17.74 7.43C18.48 7.43 19.08 8.03 19.08 8.77Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function TasteSA({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="26"
      height="38"
      viewBox="0 0 26 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.9 11.43H7.4C7.4 11.6556 7.55108 11.8533 7.76878 11.9125L7.9 11.43ZM7.9 0.5H8.4C8.4 0.223858 8.17614 0 7.9 0V0.5ZM4.41 0.5V0C4.13386 0 3.91 0.223858 3.91 0.5L4.41 0.5ZM4.41 11.43L4.54122 11.9125C4.75892 11.8533 4.91 11.6556 4.91 11.43H4.41ZM0.5 36.57H0C0 36.8461 0.223858 37.07 0.5 37.07L0.5 36.57ZM6.83 28.7V29.2C7.10614 29.2 7.33 28.9761 7.33 28.7H6.83ZM0.5 28.7H0C0 28.9761 0.223858 29.2 0.5 29.2L0.5 28.7ZM0.5 20.32V19.82C0.223858 19.82 0 20.0439 0 20.32H0.5ZM6.83 20.32H7.33C7.33 20.0439 7.10614 19.82 6.83 19.82V20.32ZM24.5 36.57V37.07H25.0214L24.9996 36.549L24.5 36.57ZM10.14 36.57L9.6407 36.5435L9.6128 37.07H10.14V36.57ZM10.96 21.1V20.6H10.4858L10.4607 21.0735L10.96 21.1ZM23.85 21.1L24.3496 21.079L24.3294 20.6H23.85V21.1ZM20.92 24.06C20.92 23.7839 20.6961 23.56 20.42 23.56C20.1439 23.56 19.92 23.7839 19.92 24.06H20.92ZM14.9 24.06C14.9 23.7839 14.6761 23.56 14.4 23.56C14.1239 23.56 13.9 23.7839 13.9 24.06H14.9ZM12.31 21.1V16.75H11.31V21.1H12.31ZM12.31 16.75C12.31 13.9933 10.6566 11.6615 8.03122 10.9475L7.76878 11.9125C9.92341 12.4985 11.31 14.4067 11.31 16.75H12.31ZM8.4 11.43V0.5H7.4V11.43H8.4ZM7.9 0H4.41V1H7.9V0ZM3.91 0.5V11.43H4.91V0.5H3.91ZM4.27878 10.9475C1.65341 11.6615 0 13.9933 0 16.75H1C1 14.4067 2.38659 12.4985 4.54122 11.9125L4.27878 10.9475ZM0 16.75V36.57H1V16.75H0ZM0.5 37.07H11.81V36.07H0.5V37.07ZM6.83 28.2H0.5V29.2H6.83V28.2ZM1 28.7V20.32H0V28.7H1ZM0.5 20.82H6.83V19.82H0.5V20.82ZM6.33 20.32V28.7H7.33V20.32H6.33ZM7.9 4.51H4.42V5.51H7.9V4.51ZM24.5 36.07H10.14V37.07H24.5V36.07ZM10.6393 36.5965L11.4593 21.1265L10.4607 21.0735L9.6407 36.5435L10.6393 36.5965ZM10.96 21.6H23.85V20.6H10.96V21.6ZM23.3504 21.121L24.0004 36.591L24.9996 36.549L24.3496 21.079L23.3504 21.121ZM19.92 24.06C19.92 25.4439 18.7939 26.57 17.41 26.57V27.57C19.3461 27.57 20.92 25.9961 20.92 24.06H19.92ZM17.41 26.57C16.0261 26.57 14.9 25.4439 14.9 24.06H13.9C13.9 25.9961 15.4739 27.57 17.41 27.57V26.57Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        fill="black"
      />
    </svg>
  );
}

export function DairyFoodHall({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="37"
      height="36"
      viewBox="0 0 37 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.82 10.7C36.0961 10.7 36.32 10.4761 36.32 10.2C36.32 9.92386 36.0961 9.7 35.82 9.7V10.7ZM27.18 9.7C26.9039 9.7 26.68 9.92386 26.68 10.2C26.68 10.4761 26.9039 10.7 27.18 10.7V9.7ZM27.27 34.88C26.9939 34.88 26.77 35.1039 26.77 35.38C26.77 35.6561 26.9939 35.88 27.27 35.88V34.88ZM36.0877 9.47698C35.9204 9.25733 35.6066 9.21493 35.387 9.38228C35.1673 9.54964 35.1249 9.86337 35.2923 10.083L36.0877 9.47698ZM32.1469 3.92995C32.423 3.92616 32.6437 3.69925 32.64 3.42313C32.6362 3.14701 32.4092 2.92625 32.1331 2.93005L32.1469 3.92995ZM22.6731 3.06005C22.397 3.06384 22.1763 3.29075 22.18 3.56687C22.1838 3.84299 22.4108 4.06375 22.6869 4.05995L22.6731 3.06005ZM35.3868 10.2697C35.5247 10.5089 35.8305 10.5911 36.0697 10.4532C36.3089 10.3153 36.3911 10.0095 36.2532 9.77029L35.3868 10.2697ZM32.4832 3.23029C32.3453 2.99105 32.0395 2.90891 31.8003 3.04682C31.5611 3.18473 31.4789 3.49047 31.6168 3.72971L32.4832 3.23029ZM18.9465 9.73001C18.6704 9.73195 18.4481 9.95737 18.45 10.2335C18.4519 10.5096 18.6774 10.7319 18.9535 10.73L18.9465 9.73001ZM27.5135 10.67C27.7896 10.6681 28.0119 10.4426 28.01 10.1665C28.0081 9.89036 27.7826 9.66808 27.5065 9.67001L27.5135 10.67ZM19.5763 10.0345C19.6892 9.78255 19.5765 9.4867 19.3245 9.37375C19.0725 9.26079 18.7767 9.37349 18.6637 9.62547L19.5763 10.0345ZM18.11 20.91C18.11 21.1861 18.3339 21.41 18.61 21.41C18.8861 21.41 19.11 21.1861 19.11 20.91H18.11ZM28.4931 35.85C28.7692 35.8483 28.9917 35.623 28.99 35.3469C28.9883 35.0708 28.763 34.8483 28.4869 34.85L28.4931 35.85ZM20.3969 34.9C20.1208 34.9017 19.8983 35.127 19.9 35.4031C19.9017 35.6792 20.127 35.9017 20.4031 35.9L20.3969 34.9ZM22.0401 3.5101C22.0457 3.78619 22.274 4.00548 22.5501 3.9999C22.8262 3.99432 23.0455 3.76599 23.0399 3.4899L22.0401 3.5101ZM22.5 1.52L21.9999 1.52L22.0001 1.5301L22.5 1.52ZM23.51 0.54L23.51 1.04001L23.5127 1.03999L23.51 0.54ZM31.04 0.5L31.04 -7.05452e-06L31.0373 7.05442e-06L31.04 0.5ZM32.06 1.47H31.56V1.48207L31.5606 1.49413L32.06 1.47ZM31.6606 3.56413C31.6739 3.83995 31.9083 4.05274 32.1841 4.03942C32.4599 4.02609 32.6727 3.79169 32.6594 3.51587L31.6606 3.56413ZM18.5323 9.85831C18.3988 10.1001 18.4866 10.4042 18.7283 10.5377C18.9701 10.6712 19.2742 10.5834 19.4077 10.3417L18.5323 9.85831ZM22.41 3.87L21.9821 3.61129L21.977 3.6197L21.9723 3.62831L22.41 3.87ZM23.35 3.86L23.7814 3.60689L23.7751 3.59682L23.35 3.86ZM26.6388 10.453C26.7785 10.6912 27.0849 10.771 27.323 10.6312C27.5612 10.4915 27.641 10.1851 27.5012 9.94697L26.6388 10.453ZM27.57 10.38C27.57 10.1039 27.3461 9.88 27.07 9.88C26.7939 9.88 26.57 10.1039 26.57 10.38H27.57ZM26.57 35.13C26.57 35.4061 26.7939 35.63 27.07 35.63C27.3461 35.63 27.57 35.4061 27.57 35.13H26.57ZM22.18 22.48L22.0059 22.9487C22.0616 22.9694 22.1206 22.98 22.18 22.98V22.48ZM17.98 20.92L18.1541 20.4513C18.0264 20.4038 17.8848 20.4106 17.7622 20.4699C17.6395 20.5293 17.5464 20.6361 17.5044 20.7657L17.98 20.92ZM14.53 19.64L14.9928 19.8293C15.0483 19.6935 15.0414 19.5402 14.974 19.41C14.9065 19.2797 14.7852 19.1857 14.6422 19.1528L14.53 19.64ZM8.8 18.32L8.91229 17.8326L8.89892 17.8299L8.8 18.32ZM6.94 18.32L6.99938 18.8165C7.02575 18.8133 7.05182 18.8081 7.07736 18.8008L6.94 18.32ZM0.5 23.98L0.0148341 23.8591C-0.022431 24.0087 0.0113623 24.1671 0.106423 24.2884C0.201483 24.4097 0.347186 24.4804 0.501315 24.48L0.5 23.98ZM23.31 23.92L23.3113 24.42C23.5869 24.4193 23.81 24.1956 23.81 23.92H23.31ZM22.19 22.48L22.3222 21.9978C22.2791 21.986 22.2347 21.98 22.19 21.98V22.48ZM23.37 25.3V25.8C23.6461 25.8 23.87 25.5761 23.87 25.3H23.37ZM23.35 24L23.8308 23.8626C23.7694 23.648 23.5732 23.5 23.35 23.5V24ZM0.57 24V23.5C0.354785 23.5 0.163715 23.6377 0.0956583 23.8419L0.57 24ZM2.84 35.4V35.9C3.10335 35.9 3.32156 35.6957 3.33891 35.4329L2.84 35.4ZM6.86 35.4L6.36109 35.4329C6.37844 35.6957 6.59665 35.9 6.86 35.9V35.4ZM12.6 35.4V35.9C12.7434 35.9 12.8799 35.8384 12.9748 35.7309C13.0698 35.6234 13.1139 35.4803 13.0961 35.338L12.6 35.4ZM16.43 35.4L15.9339 35.338C15.9161 35.4803 15.9602 35.6234 16.0552 35.7309C16.1501 35.8384 16.2866 35.9 16.43 35.9V35.4ZM23.34 29.06H23.84C23.84 28.8245 23.6757 28.621 23.4455 28.5713L23.34 29.06ZM23.35 25.3V24.8C23.3145 24.8 23.2792 24.8038 23.2445 24.8113L23.35 25.3ZM35.82 9.7H27.18V10.7H35.82V9.7ZM27.27 35.88H35.33V34.88H27.27V35.88ZM35.33 35.88C36.1761 35.88 36.87 35.1861 36.87 34.34H35.87C35.87 34.6339 35.6239 34.88 35.33 34.88V35.88ZM36.87 34.34V11.47H35.87V34.34H36.87ZM36.87 11.47C36.87 11.0896 36.7527 10.7007 36.6085 10.3692C36.4619 10.0325 36.2713 9.7179 36.0877 9.47698L35.2923 10.083C35.4287 10.2621 35.578 10.5075 35.6915 10.7683C35.8073 11.0343 35.87 11.2804 35.87 11.47H36.87ZM32.1331 2.93005L22.6731 3.06005L22.6869 4.05995L32.1469 3.92995L32.1331 2.93005ZM36.2532 9.77029L32.4832 3.23029L31.6168 3.72971L35.3868 10.2697L36.2532 9.77029ZM18.9535 10.73L27.5135 10.67L27.5065 9.67001L18.9465 9.73001L18.9535 10.73ZM19.11 11.59C19.11 11.1425 19.3109 10.6265 19.5763 10.0345L18.6637 9.62547C18.4091 10.1935 18.11 10.8975 18.11 11.59H19.11ZM19.11 20.91V11.59H18.11V20.91H19.11ZM28.4869 34.85L20.3969 34.9L20.4031 35.9L28.4931 35.85L28.4869 34.85ZM23.0399 3.4899L22.9999 1.5099L22.0001 1.5301L22.0401 3.5101L23.0399 3.4899ZM23 1.52C23 1.26914 23.213 1.04 23.51 1.04V0.04C22.687 0.04 22 0.690855 22 1.52H23ZM23.5127 1.03999L31.0427 0.999993L31.0373 7.05442e-06L23.5073 0.0400071L23.5127 1.03999ZM31.04 1C31.3504 1 31.56 1.23196 31.56 1.47H32.56C32.56 0.628042 31.8496 0 31.04 0V1ZM31.5606 1.49413L31.6606 3.56413L32.6594 3.51587L32.5594 1.44587L31.5606 1.49413ZM19.4077 10.3417L22.8477 4.11169L21.9723 3.62831L18.5323 9.85831L19.4077 10.3417ZM22.8379 4.12871C22.8727 4.07102 22.9005 4.04859 22.9094 4.04262C22.9163 4.038 22.9066 4.04607 22.8837 4.04624C22.8607 4.04641 22.8504 4.03847 22.8562 4.0423C22.8641 4.04747 22.8909 4.06824 22.9249 4.12318L23.7751 3.59682C23.5854 3.29032 23.2741 3.04334 22.8763 3.04626C22.4787 3.04919 22.1701 3.30048 21.9821 3.61129L22.8379 4.12871ZM22.9188 4.11303L26.6388 10.453L27.5012 9.94697L23.7812 3.60697L22.9188 4.11303ZM26.57 10.38V35.13H27.57V10.38H26.57ZM20.06 31.12C20.06 31.7239 19.5739 32.21 18.97 32.21V33.21C20.1261 33.21 21.06 32.2761 21.06 31.12H20.06ZM18.97 32.21C18.3661 32.21 17.88 31.7239 17.88 31.12H16.88C16.88 32.2761 17.8139 33.21 18.97 33.21V32.21ZM17.88 31.12C17.88 30.5161 18.3661 30.03 18.97 30.03V29.03C17.8139 29.03 16.88 29.9639 16.88 31.12H17.88ZM18.97 30.03C19.5739 30.03 20.06 30.5161 20.06 31.12H21.06C21.06 29.9639 20.1261 29.03 18.97 29.03V30.03ZM8.89 20.93C8.89 21.0603 8.81985 21.2189 8.62668 21.3625C8.43368 21.506 8.1433 21.61 7.8 21.61V22.61C8.3367 22.61 8.84132 22.449 9.22332 22.165C9.60515 21.8811 9.89 21.4497 9.89 20.93H8.89ZM7.8 21.61C7.4567 21.61 7.16632 21.506 6.97332 21.3625C6.78015 21.2189 6.71 21.0603 6.71 20.93H5.71C5.71 21.4497 5.99485 21.8811 6.37668 22.165C6.75868 22.449 7.2633 22.61 7.8 22.61V21.61ZM6.71 20.93C6.71 20.7997 6.78015 20.6411 6.97332 20.4975C7.16632 20.354 7.4567 20.25 7.8 20.25V19.25C7.2633 19.25 6.75868 19.411 6.37668 19.695C5.99485 19.9789 5.71 20.4103 5.71 20.93H6.71ZM7.8 20.25C8.1433 20.25 8.43368 20.354 8.62668 20.4975C8.81985 20.6411 8.89 20.7997 8.89 20.93H9.89C9.89 20.4103 9.60515 19.9789 9.22332 19.695C8.84132 19.411 8.3367 19.25 7.8 19.25V20.25ZM22.3541 22.0113L18.1541 20.4513L17.8059 21.3887L22.0059 22.9487L22.3541 22.0113ZM17.5044 20.7657C17.3271 21.3125 16.8301 21.7 16.24 21.7V22.7C17.2899 22.7 18.1529 22.0075 18.4556 21.0743L17.5044 20.7657ZM16.24 21.7C15.4961 21.7 14.89 21.0939 14.89 20.35H13.89C13.89 21.6461 14.9439 22.7 16.24 22.7V21.7ZM14.89 20.35C14.89 20.1671 14.9265 19.9913 14.9928 19.8293L14.0672 19.4507C13.9535 19.7287 13.89 20.0329 13.89 20.35H14.89ZM14.6422 19.1528L8.91224 17.8328L8.68776 18.8072L14.4178 20.1272L14.6422 19.1528ZM8.89892 17.8299C8.3 17.709 7.78684 17.7085 7.41957 17.7392C7.23576 17.7546 7.08773 17.7779 6.98276 17.7981C6.93024 17.8082 6.88838 17.8176 6.85809 17.8249C6.84295 17.8285 6.83068 17.8317 6.8214 17.8341C6.81676 17.8353 6.81287 17.8364 6.80974 17.8373C6.80817 17.8377 6.8068 17.8381 6.80561 17.8384C6.80502 17.8386 6.80448 17.8387 6.80398 17.8389C6.80373 17.8389 6.8035 17.839 6.80327 17.8391C6.80316 17.8391 6.803 17.8391 6.80295 17.8391C6.80279 17.8392 6.80264 17.8392 6.94 18.32C7.07736 18.8008 7.07721 18.8008 7.07707 18.8008C7.07703 18.8009 7.07688 18.8009 7.0768 18.8009C7.07662 18.801 7.07645 18.801 7.0763 18.8011C7.07599 18.8012 7.07573 18.8012 7.07551 18.8013C7.07507 18.8014 7.07482 18.8015 7.07474 18.8015C7.07459 18.8015 7.07516 18.8014 7.07643 18.8011C7.07896 18.8004 7.0843 18.799 7.09233 18.7971C7.10841 18.7932 7.13523 18.7871 7.17193 18.78C7.24539 18.7659 7.35799 18.7479 7.50293 18.7358C7.79316 18.7115 8.21 18.711 8.70108 18.8101L8.89892 17.8299ZM6.88062 17.8235C3.66921 18.2076 0.81617 20.6431 0.0148341 23.8591L0.985166 24.1009C1.68383 21.2969 4.19079 19.1524 6.99938 18.8165L6.88062 17.8235ZM0.501315 24.48L23.3113 24.42L23.3087 23.42L0.498685 23.48L0.501315 24.48ZM23.81 23.92C23.81 23.4794 23.635 23.0569 23.3777 22.7249C23.1199 22.3923 22.7527 22.1158 22.3222 21.9978L22.0578 22.9622C22.2473 23.0142 22.4401 23.1477 22.5873 23.3376C22.735 23.5281 22.81 23.7406 22.81 23.92H23.81ZM22.19 21.98H22.18V22.98H22.19V21.98ZM5.01 27.74C5.01 28.3439 4.52386 28.83 3.92 28.83V29.83C5.07614 29.83 6.01 28.8961 6.01 27.74H5.01ZM3.92 28.83C3.31614 28.83 2.83 28.3439 2.83 27.74H1.83C1.83 28.8961 2.76386 29.83 3.92 29.83V28.83ZM2.83 27.74C2.83 27.1361 3.31614 26.65 3.92 26.65V25.65C2.76386 25.65 1.83 26.5839 1.83 27.74H2.83ZM3.92 26.65C4.52386 26.65 5.01 27.1361 5.01 27.74H6.01C6.01 26.5839 5.07614 25.65 3.92 25.65V26.65ZM12.95 29.15C12.95 29.9639 12.2939 30.62 11.48 30.62V31.62C12.8461 31.62 13.95 30.5161 13.95 29.15H12.95ZM11.48 30.62C10.6695 30.62 10.02 29.9672 10.02 29.15H9.02C9.02 30.5128 10.1105 31.62 11.48 31.62V30.62ZM10.02 29.15C10.02 28.3345 10.6778 27.68 11.48 27.68V26.68C10.1222 26.68 9.02 27.7855 9.02 29.15H10.02ZM11.48 27.68C12.2855 27.68 12.95 28.3378 12.95 29.15H13.95C13.95 27.7822 12.8345 26.68 11.48 26.68V27.68ZM23.87 25.3V24.22H22.87V25.3H23.87ZM23.87 24.22C23.87 24.1527 23.8733 24.0114 23.8308 23.8626L22.8692 24.1374C22.867 24.1295 22.8678 24.128 22.8687 24.1407C22.8691 24.1473 22.8695 24.1564 22.8698 24.17C22.87 24.184 22.87 24.1992 22.87 24.22H23.87ZM23.35 23.5H0.57V24.5H23.35V23.5ZM0.0956583 23.8419C0.0463624 23.9898 0 24.1764 0 24.38H1C1 24.3236 1.01364 24.2502 1.04434 24.1581L0.0956583 23.8419ZM0 24.38V34.31H1V24.38H0ZM0 34.31C0 35.1861 0.713858 35.9 1.59 35.9V34.9C1.26614 34.9 1 34.6339 1 34.31H0ZM1.59 35.9H2.84V34.9H1.59V35.9ZM3.33891 35.4329C3.39205 34.6283 4.05069 34 4.85 34V33C3.50931 33 2.42795 34.0517 2.34109 35.3671L3.33891 35.4329ZM4.85 34C5.64931 34 6.30795 34.6283 6.36109 35.4329L7.35891 35.3671C7.27205 34.0517 6.19069 33 4.85 33V34ZM6.86 35.9H12.6V34.9H6.86V35.9ZM13.0961 35.338C13.09 35.2886 13.08 35.2458 13.0721 35.2152C13.0652 35.1882 13.0555 35.1552 13.0526 35.1446C13.0478 35.1277 13.047 35.1236 13.0471 35.1242C13.0474 35.1255 13.05 35.1389 13.05 35.16H12.05C12.05 35.2757 12.0785 35.3748 12.0899 35.4154C12.0982 35.4448 12.1004 35.4518 12.1038 35.4648C12.1062 35.4742 12.105 35.4714 12.1039 35.462L13.0961 35.338ZM13.05 35.16C13.05 34.3461 13.7061 33.69 14.52 33.69V32.69C13.1539 32.69 12.05 33.7939 12.05 35.16H13.05ZM14.52 33.69C15.3305 33.69 15.98 34.3428 15.98 35.16H16.98C16.98 33.7972 15.8895 32.69 14.52 32.69V33.69ZM15.98 35.16C15.98 35.1313 15.987 35.1152 15.9786 35.1443C15.9768 35.1506 15.9659 35.1867 15.9591 35.2118C15.9507 35.2432 15.9403 35.2868 15.9339 35.338L16.9261 35.462C16.9247 35.4732 16.923 35.4781 16.925 35.471C16.9285 35.4577 16.9295 35.4556 16.9389 35.4232C16.953 35.3748 16.98 35.2787 16.98 35.16H15.98ZM16.43 35.9H22.25V34.9H16.43V35.9ZM22.25 35.9C23.1261 35.9 23.84 35.1861 23.84 34.31H22.84C22.84 34.6339 22.5739 34.9 22.25 34.9V35.9ZM23.84 34.31V29.06H22.84V34.31H23.84ZM23.4455 28.5713C22.777 28.4269 22.29 27.8659 22.29 27.18H21.29C21.29 28.3741 22.143 29.3131 23.2345 29.5487L23.4455 28.5713ZM22.29 27.18C22.29 26.4977 22.7832 25.9339 23.4555 25.7887L23.2445 24.8113C22.1568 25.0461 21.29 25.9823 21.29 27.18H22.29ZM23.35 25.8H23.37V24.8H23.35V25.8Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}

export function CompJudging({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="29"
      height="36"
      viewBox="0 0 29 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.99 29.64H0.559998V3.06001H7.68M7.68 3.06001L10.09 0.950012H13.6L16.02 3.06001M7.68 3.06001V6.04001H16.02V3.06001M16.02 3.06001H23.13V10.03M8.99 19.29H5.74M10.65 14.8H5.74M18.17 10.3H5.74M9.38 23.79H5.74M18.65 28.42L16.02 34.95L14.35 32.12L11.19 33.01L14.12 25.71M20.84 28.42L23.47 34.95L25.14 32.12L28.31 33.01L25.37 25.71M28.02 20.76C28.02 21.45 26.73 21.95 26.56 22.58C26.39 23.21 27.25 24.32 26.92 24.89C26.59 25.46 25.21 25.26 24.74 25.74C24.27 26.22 24.48 27.59 23.89 27.92C23.3 28.25 22.23 27.39 21.58 27.56C20.93 27.73 20.44 29.02 19.76 29.02C19.08 29.02 18.57 27.73 17.94 27.56C17.31 27.39 16.2 28.25 15.63 27.92C15.06 27.59 15.26 26.21 14.78 25.74C14.3 25.27 12.93 25.48 12.6 24.89C12.27 24.3 13.13 23.23 12.96 22.58C12.79 21.93 11.5 21.44 11.5 20.76C11.5 20.08 12.79 19.57 12.96 18.94C13.13 18.31 12.27 17.2 12.6 16.63C12.93 16.06 14.31 16.26 14.78 15.78C15.25 15.3 15.04 13.93 15.63 13.6C16.22 13.27 17.29 14.13 17.94 13.96C18.59 13.79 19.08 12.5 19.76 12.5C20.44 12.5 20.95 13.79 21.58 13.96C22.21 14.13 23.32 13.27 23.89 13.6C24.46 13.93 24.26 15.31 24.74 15.78C25.22 16.25 26.59 16.04 26.92 16.63C27.25 17.22 26.39 18.29 26.56 18.94C26.73 19.59 28.02 20.08 28.02 20.76ZM19.75 16.7L20.97 19.18L23.71 19.58L21.73 21.51L22.2 24.24L19.75 22.95L17.29 24.24L17.76 21.51L15.78 19.58L18.52 19.18L19.75 16.7Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function YellowBrickRoad({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="37"
      height="36"
      viewBox="0 0 37 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_889_1463)">
        <mask
          id="mask0_889_1463"
          maskUnits="userSpaceOnUse"
          x="3"
          y="2"
          width="31"
          height="32"
        >
          <path
            d="M18.52 33.01C26.8374 33.01 33.58 26.2674 33.58 17.95C33.58 9.63261 26.8374 2.89001 18.52 2.89001C10.2026 2.89001 3.45999 9.63261 3.45999 17.95C3.45999 26.2674 10.2026 33.01 18.52 33.01Z"
            className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
            strokeWidth={strokeWidth}
          />
        </mask>
        <g mask="url(#mask0_889_1463)">
          <path
            d="M29.03 23.76C28.58 28.65 27.18 33.11 24.82 35.73L7.88 35.8C12.61 32.73 15.69 28.17 17.54 23.4"
            className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
            strokeWidth={strokeWidth}
            strokeLinejoin="round"
          />
          <path
            d="M19.88 10.62C19.85 7.08002 19.21 4.26002 18.24 2.96002C15.1 -1.21998 24.21 3.01002 24.21 3.01002C25.89 4.88002 27.15 7.56002 27.98 10.62"
            className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
            strokeWidth={strokeWidth}
            strokeLinejoin="round"
          />
          <path
            d="M21.72 23.4C20.68 28.94 18.64 34.29 15.36 37.88"
            className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
            strokeWidth={strokeWidth}
            strokeLinejoin="round"
          />
          <path
            d="M19.88 1.28C21.23 2.87 22.15 6.34 22.47 10.63"
            className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
            strokeWidth={strokeWidth}
            strokeLinejoin="round"
          />
          <path
            d="M25.49 23.91C25.07 29.09 23.76 34.11 21.19 37.79"
            className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
            strokeWidth={strokeWidth}
            strokeLinejoin="round"
          />
          <path
            d="M20.83 0.910004C22.45 2.37 23.89 5.96 24.76 10.47"
            className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
            strokeWidth={strokeWidth}
            strokeLinejoin="round"
          />
          <path
            d="M13.73 30.44L19.73 30.5"
            className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
            strokeWidth={strokeWidth}
            strokeLinejoin="round"
          />
          <path
            d="M19.73 7.93999L22.11 7.70999"
            className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
            strokeWidth={strokeWidth}
            strokeLinejoin="round"
          />
          <path
            d="M18.59 33.09L23.92 32.56"
            className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
            strokeWidth={strokeWidth}
            strokeLinejoin="round"
          />
          <path
            d="M20.82 27.24L25.08 26.82"
            className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
            strokeWidth={strokeWidth}
            strokeLinejoin="round"
          />
          <path
            d="M22.38 9.59L24.57 9.37"
            className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
            strokeWidth={strokeWidth}
            strokeLinejoin="round"
          />
          <path
            d="M21.93 5.89001L23.53 5.73001"
            className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
            strokeWidth={strokeWidth}
            strokeLinejoin="round"
          />
          <path
            d="M24.99 28.68L28.35 28.35"
            className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
            strokeWidth={strokeWidth}
            strokeLinejoin="round"
          />
          <path
            d="M24.19 7.94999L26.98 7.67999"
            className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
            strokeWidth={strokeWidth}
            strokeLinejoin="round"
          />
        </g>
        <path
          d="M18.52 33.01C26.8374 33.01 33.58 26.2674 33.58 17.95C33.58 9.63261 26.8374 2.89001 18.52 2.89001C10.2026 2.89001 3.45999 9.63261 3.45999 17.95C3.45999 26.2674 10.2026 33.01 18.52 33.01Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
          strokeWidth={strokeWidth}
          strokeLinejoin="round"
        />
        <path
          d="M18.43 34.95C27.8188 34.95 35.43 27.3389 35.43 17.95C35.43 8.56117 27.8188 0.950012 18.43 0.950012C9.04115 0.950012 1.42999 8.56117 1.42999 17.95C1.42999 27.3389 9.04115 34.95 18.43 34.95Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
          strokeWidth={strokeWidth}
          strokeLinejoin="round"
        />
        <path
          d="M9.33 21.53V18.2L6.37 12.66H8.6L11.35 18.23V21.52H9.34L9.33 21.53ZM11.49 17.98L10.49 15.97L12.13 12.67H14.35L11.5 17.99L11.49 17.98Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
          strokeWidth={strokeWidth}
        />
        <path
          d="M15.48 21.53V12.65H17.48V21.53H15.48ZM21.97 19.75C21.88 20.02 21.75 20.27 21.58 20.48C21.39 20.72 21.18 20.9 20.95 21.04C20.72 21.18 20.46 21.29 20.19 21.36C19.92 21.44 19.64 21.48 19.35 21.5C19.06 21.52 18.78 21.53 18.5 21.53H17.8V19.87C17.88 19.87 17.94 19.87 17.96 19.87C17.98 19.87 17.99 19.87 18 19.88C18 19.88 18.02 19.88 18.04 19.89C18.06 19.89 18.12 19.89 18.21 19.89C18.41 19.89 18.62 19.88 18.84 19.86C19.06 19.84 19.26 19.79 19.44 19.7C19.62 19.62 19.76 19.5 19.88 19.34C20 19.18 20.06 18.97 20.06 18.71C20.06 18.47 20.01 18.27 19.9 18.12C19.79 17.97 19.65 17.86 19.48 17.78C19.31 17.7 19.12 17.66 18.92 17.63C18.71 17.61 18.51 17.6 18.32 17.6C18.23 17.6 18.17 17.6 18.14 17.6C18.11 17.6 18.09 17.6 18.07 17.61C18.05 17.61 18.03 17.61 18 17.62C17.97 17.62 17.91 17.62 17.82 17.62V16.02C17.91 16.02 17.97 16.02 18 16.02C18.03 16.02 18.05 16.03 18.06 16.04C18.07 16.04 18.09 16.06 18.12 16.06C18.15 16.06 18.21 16.06 18.3 16.06C18.45 16.06 18.62 16.06 18.81 16.04C19 16.03 19.17 15.99 19.34 15.93C19.5 15.87 19.64 15.78 19.75 15.66C19.86 15.54 19.91 15.38 19.91 15.18C19.91 14.98 19.86 14.8 19.75 14.67C19.64 14.54 19.51 14.45 19.34 14.38C19.17 14.31 19 14.27 18.81 14.25C18.62 14.23 18.44 14.22 18.27 14.22C18.18 14.22 18.12 14.22 18.09 14.22C18.06 14.22 18.05 14.22 18.03 14.23C18.02 14.23 18 14.23 17.97 14.24C17.94 14.24 17.89 14.24 17.79 14.24V12.57H17.93C17.93 12.57 17.93 12.56 17.96 12.56H18.1C18.51 12.56 18.93 12.58 19.37 12.62C19.81 12.66 20.21 12.75 20.59 12.9C20.96 13.05 21.27 13.27 21.5 13.57C21.74 13.87 21.85 14.28 21.85 14.81C21.85 15.29 21.74 15.67 21.53 15.94C21.32 16.21 21.01 16.47 20.62 16.69C21.09 16.91 21.46 17.19 21.71 17.53C21.96 17.87 22.09 18.31 22.09 18.84C22.09 19.12 22.05 19.39 21.96 19.66L21.97 19.75Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
          strokeWidth={strokeWidth}
        />
        <path
          d="M23.4 21.54V12.66H25.39V21.54H23.4ZM28.02 21.53C27.92 21.33 27.83 21.12 27.75 20.91C27.67 20.7 27.61 20.48 27.57 20.25C27.53 20.02 27.5 19.8 27.47 19.58C27.44 19.36 27.4 19.16 27.34 18.98C27.27 18.8 27.16 18.65 27.01 18.53C26.86 18.41 26.63 18.33 26.34 18.3C26.23 18.3 26.15 18.28 26.11 18.27C26.07 18.27 26.03 18.26 26 18.26H25.66L25.68 16.66C25.82 16.66 25.97 16.66 26.1 16.66C26.23 16.66 26.38 16.66 26.52 16.66C26.76 16.66 26.95 16.65 27.11 16.62C27.27 16.59 27.39 16.53 27.49 16.44C27.59 16.35 27.65 16.21 27.69 16.04C27.73 15.87 27.75 15.63 27.75 15.34C27.75 15.1 27.73 14.92 27.68 14.78C27.63 14.64 27.56 14.54 27.47 14.47C27.38 14.4 27.26 14.36 27.12 14.34C26.98 14.32 26.82 14.31 26.64 14.31C26.48 14.31 26.32 14.31 26.16 14.32C26 14.32 25.85 14.33 25.7 14.33H25.65V12.65C25.98 12.65 26.31 12.66 26.64 12.65C26.97 12.64 27.28 12.66 27.58 12.7C27.88 12.74 28.15 12.8 28.42 12.89C28.68 12.98 28.91 13.12 29.09 13.31C29.27 13.5 29.42 13.75 29.53 14.05C29.64 14.35 29.69 14.73 29.69 15.19C29.69 15.41 29.65 15.64 29.58 15.88C29.51 16.12 29.4 16.34 29.26 16.55C29.12 16.76 28.95 16.92 28.76 17.05C28.57 17.18 28.35 17.25 28.1 17.25C28.14 17.27 28.18 17.28 28.23 17.3C28.28 17.32 28.31 17.33 28.36 17.35C28.6 17.45 28.79 17.61 28.93 17.82C29.06 18.03 29.17 18.27 29.24 18.53C29.31 18.79 29.36 19.06 29.4 19.33C29.44 19.6 29.47 19.85 29.51 20.06C29.56 20.34 29.63 20.59 29.73 20.83C29.83 21.06 29.95 21.3 30.09 21.53H27.99H28.02Z"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
          strokeWidth={strokeWidth}
        />
        <path
          d="M32.69 23.48H4.81"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
          strokeWidth={strokeWidth}
          strokeLinejoin="round"
        />
        <path
          d="M31.66 10.51H5.31"
          className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
          strokeWidth={strokeWidth}
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_889_1463">
          <rect
            width="36.87"
            height="35.91"
            className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
            strokeWidth={strokeWidth}
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CellarDoor({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="19"
      height="35"
      viewBox="0 0 19 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.91 33.67H0.5V15.44C0.5 13.1 1.9 11.15 4.1 10.55V0.5H7.31V4.64M7.31 4.64V10.55C9.51 11.15 10.91 13.1 10.91 15.44V16.5M7.31 4.64H4.1M12.98 26.94C12.98 26.67 12.93 26.52 12.63 26.44C10.61 25.89 9.38 24.24 9.38 22.15C9.38 20.33 9.74 18.58 10.37 16.87C10.48 16.58 10.62 16.5 10.92 16.5C12.76 16.51 14.61 16.51 16.45 16.5C16.76 16.5 16.92 16.58 17.03 16.89C17.68 18.65 18.04 20.46 18.01 22.34C17.98 24.26 16.71 25.9 14.87 26.43C14.74 26.47 14.6 26.5 14.44 26.55V32.36C14.92 32.36 15.38 32.36 15.84 32.36C16.66 32.39 17.2 32.92 17.27 33.76H10.13C10.13 32.96 10.72 32.38 11.55 32.36C12 32.36 12.45 32.36 12.97 32.36H12.98V26.94ZM6.33 26.43H0.51V18.72H6.33V26.43Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
    </svg>
  );
}

export function Comps({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="27"
      height="35"
      viewBox="0 0 27 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8 24.22L7.87999 33.95L5.39999 29.73L0.679993 31.05L5.05999 20.19M15.07 24.22L18.99 33.95L21.47 29.73L26.19 31.05L21.81 20.19M25.76 12.81C25.76 13.83 23.83 14.59 23.58 15.53C23.33 16.47 24.6 18.12 24.11 18.97C23.62 19.82 21.56 19.53 20.86 20.23C20.16 20.93 20.47 22.98 19.6 23.48C18.73 23.98 17.13 22.69 16.16 22.95C15.19 23.21 14.46 25.13 13.44 25.13C12.42 25.13 11.66 23.2 10.72 22.95C9.77999 22.7 8.12999 23.97 7.27999 23.48C6.42999 22.99 6.71999 20.93 6.01999 20.23C5.31999 19.53 3.26999 19.84 2.76999 18.97C2.26999 18.1 3.55999 16.5 3.29999 15.53C3.03999 14.56 1.11999 13.83 1.11999 12.81C1.11999 11.79 3.04999 11.03 3.29999 10.09C3.54999 9.14999 2.27999 7.49999 2.76999 6.64999C3.25999 5.79999 5.31999 6.08999 6.01999 5.38999C6.71999 4.68999 6.40999 2.63999 7.27999 2.13999C8.14999 1.63999 9.74999 2.92999 10.72 2.66999C11.69 2.40999 12.42 0.48999 13.44 0.48999C14.46 0.48999 15.22 2.41999 16.16 2.66999C17.1 2.91999 18.75 1.64999 19.6 2.13999C20.45 2.62999 20.16 4.68999 20.86 5.38999C21.56 6.08999 23.61 5.77999 24.11 6.64999C24.61 7.51999 23.32 9.11999 23.58 10.09C23.84 11.06 25.76 11.79 25.76 12.81ZM13.43 6.75999L15.26 10.46L19.34 11.05L16.39 13.93L17.09 17.99L13.43 16.07L9.77999 17.99L10.48 13.93L7.52999 11.05L11.61 10.46L13.43 6.75999Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CompResults({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="31"
      height="44"
      viewBox="0 0 31 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.09 36.98C18.78 36.98 18.48 36.9 18.19 36.75L15.33 35.16C15.19 35.08 15.02 35.08 14.88 35.16L12.02 36.75C11.4 37.1 10.65 37.06 10.06 36.65C9.47 36.24 9.18 35.54 9.3 34.83L9.88 31.28C9.9 31.13 9.86 30.99 9.75 30.88L7.28 28.34C6.79 27.84 6.63 27.12 6.85 26.46C7.07 25.8 7.64 25.32 8.33 25.22L11.63 24.71C11.78 24.69 11.92 24.59 11.98 24.45L13.43 21.35C13.74 20.69 14.38 20.29 15.1 20.29C15.82 20.29 16.47 20.7 16.77 21.35L18.22 24.45C18.29 24.59 18.42 24.69 18.57 24.71L21.88 25.22C22.57 25.33 23.13 25.8 23.35 26.46C23.57 27.12 23.41 27.84 22.92 28.34L20.45 30.88C20.35 30.99 20.3 31.14 20.32 31.28L20.9 34.83C21.02 35.54 20.72 36.23 20.14 36.65C19.82 36.87 19.45 36.99 19.08 36.99L19.09 36.98ZM15.11 33.59C15.44 33.59 15.77 33.67 16.07 33.84L18.93 35.43C19.1 35.52 19.23 35.46 19.29 35.41C19.34 35.37 19.47 35.26 19.44 35.06L18.86 31.51C18.76 30.9 18.96 30.27 19.39 29.83L21.86 27.28C22 27.14 21.96 26.98 21.94 26.92C21.92 26.86 21.85 26.71 21.66 26.68L18.35 26.17C17.7 26.07 17.15 25.66 16.87 25.06L15.42 21.96C15.34 21.78 15.17 21.76 15.11 21.76C15.05 21.76 14.88 21.78 14.8 21.96L13.35 25.06C13.07 25.66 12.52 26.07 11.87 26.17L8.57 26.68C8.38 26.71 8.31 26.86 8.29 26.92C8.27 26.98 8.24 27.14 8.37 27.28L10.84 29.82C11.27 30.26 11.47 30.89 11.37 31.51L10.79 35.06C10.76 35.26 10.88 35.37 10.94 35.41C11.01 35.46 11.14 35.52 11.3 35.43L14.16 33.84C14.46 33.67 14.79 33.59 15.11 33.59Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
      />
      <path
        d="M15.11 43.74C6.78 43.74 0 36.96 0 28.63C0 20.3 6.78 13.52 15.11 13.52C23.44 13.52 30.22 20.3 30.22 28.63C30.22 36.96 23.44 43.74 15.11 43.74ZM15.11 15.02C7.61 15.02 1.5 21.13 1.5 28.63C1.5 36.13 7.61 42.24 15.11 42.24C22.61 42.24 28.72 36.13 28.72 28.63C28.72 21.13 22.61 15.02 15.11 15.02Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
      />
      <path
        d="M20.08 14.9H18.58V1.5H11.63V14.9H10.13V0.75C10.13 0.34 10.47 0 10.88 0H19.33C19.74 0 20.08 0.34 20.08 0.75V14.9Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
      />
      <path
        d="M23.82 17.31L22.7 16.31L26.79 11.71C26.94 11.54 27.03 11.32 27.03 11.09V2.44C27.03 1.92 26.61 1.5 26.09 1.5H4.13C3.61 1.5 3.19 1.92 3.19 2.44V11.09C3.19 11.32 3.27 11.54 3.43 11.71L7.52 16.31L6.4 17.31L2.31 12.71C1.91 12.26 1.69 11.69 1.69 11.09V2.44C1.69 1.09 2.78 0 4.13 0H26.09C27.43 0 28.53 1.09 28.53 2.44V11.09C28.53 11.69 28.31 12.26 27.91 12.71L23.82 17.31Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}

export function MainArena({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="38"
      height="30"
      viewBox="0 0 38 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.64 18.72C26.39 19.32 27.71 20.21 27.99 20.49C28.19 20.69 28.13 20.87 28.23 21.24C28.33 21.63 28.46 21.6 28.51 21.85C28.64 22.61 28.39 23.25 28.11 24.04C28.03 24.27 27.63 24.81 27.66 25.05C27.69 25.31 27.86 25.47 27.94 25.73C28.01 25.96 27.81 26.17 27.73 26.36C27.65 26.54 27.51 26.93 27.92 27.04C28.11 27.09 28.51 27.25 28.77 27.34C29.17 27.48 29.35 27.49 29.35 27.12C29.35 26.72 29.29 26.45 29.18 26.16C29.11 25.96 29.16 25.7 29.09 25.31C28.92 24.44 29.57 23.15 29.95 21.92C30.01 21.72 30.13 21.14 30.03 20.71C29.93 20.27 29.78 20.1 29.59 19.87C28.99 19.13 28.2 17.87 27.72 17.11M30.83 2.58C29.1 2.41 27.56 3.2 26.29 4.2C24.32 5.75 23.66 6.84 23.28 7.96C22.77 8.26 20.82 8.76 18.76 8.79C17.77 8.81 14.99 8.53 13.44 8.08C12.09 7.68 9.68001 7.94 7.88001 9.61C4.43001 8.15 1.63001 10.96 1.63001 14.45C1.63001 19.66 2.37001 21.2 1.01001 23.45C2.74001 22.54 4.58001 21.17 5.06001 17.31C5.44001 14.17 4.66001 11.43 7.19001 11.07M23.27 7.97C24.24 7.77 25.21 7.06 27.18 5.51C27.81 5.02 28.65 4.34 29.81 4.03C30.38 3.68 30.72 2.79 30.97 2.29C31.2 1.82 31.75 1.49 32.05 1C32.28 1.24 32.12 3.46 31.87 4.03M34.52 4.84C33.54 4.33 32.67 4.05 31.91 3.93M33.9 2.89C33.9 2.46 33.95 1.93 33.76 1.32C33.56 1.75 32.95 2.21 32.72 2.64M7.87001 9.62C5.71001 12.32 8.69001 16.74 7.04001 19.25C6.55001 20 5.93001 20.56 6.33001 22.22C6.48001 22.84 6.68001 24.27 6.42001 25.77C6.33001 26.3 6.09001 26.64 6.18001 26.93C6.33001 27.4 7.01001 27.52 7.12001 27.76C7.21001 27.95 7.08001 28.29 7.05001 28.49C7.02001 28.69 7.11001 29.08 7.53001 29.08H8.55001C8.97001 29.08 9.19001 29.06 9.06001 28.74C8.91001 28.37 8.78001 28.19 8.50001 27.91C8.37001 27.74 8.17001 27.2 8.03001 27.02C7.56001 26.43 7.70001 23.55 7.74001 22.84C7.77001 22.37 8.06001 21.98 8.34001 21.47C8.64001 20.91 8.91001 20.25 9.04001 20.07C9.72001 19.12 10.13 19.27 11.54 18.05C12.29 17.4 12.84 16.78 13.23 16.43C13.9 15.82 13.98 15.77 14.65 16.21C15.5 16.77 17.08 17.8 18.85 18.29C20.29 18.69 21.98 18.74 22.97 18.34C23.08 19.07 23.23 19.7 23.25 20.53C23.25 20.81 23.09 21.08 23.05 21.47C23.01 21.87 23.13 22.08 23.18 22.33C23.3 22.96 23.33 24.99 23.07 25.91C23 26.14 22.79 26.66 22.84 26.89C22.95 27.37 23.39 27.27 23.52 27.51C23.7 27.82 23.32 28.16 23.3 28.36C23.27 28.56 23.25 28.96 23.67 28.95C23.86 28.95 24.26 28.95 24.54 28.95C24.96 28.95 25.24 28.95 25.08 28.64C24.9 28.28 24.77 28.06 24.58 27.81C24.45 27.64 24.45 27.44 24.31 26.98C24.15 26.46 24.44 23.36 24.59 22.64C24.63 22.43 24.87 22.22 24.95 21.78C25.04 21.34 24.95 21.02 24.98 20.73C25.02 20.37 25.28 19.71 25.63 18.73C25.91 17.96 27.17 17.51 27.7 17.12C28.09 16.84 28.22 16.43 28.57 15.47C28.89 14.62 28.63 13.49 28.68 13.02C28.77 12.12 29.26 11.47 29.65 10.92C30.15 10.2 30.43 9.45 30.7 9.1C31.08 8.62 31.28 8.99 32.23 9.29C32.71 9.44 33.96 9.59 34.35 9.77C34.65 9.92 34.83 10.26 35.08 10.46C35.48 10.77 35.76 10.44 35.9 10.49C36.15 10.58 36.37 10.33 36.24 10.11C36.56 10.25 36.74 10.11 36.78 9.78C36.84 9.61 37.23 9.12 37 8.63C36.84 8.27 36.64 8.35 36.39 8C36.14 7.65 35.31 6.22 35.12 5.94C35.2 5.46 34.82 5.22 34.52 4.85C34.68 4.64 35.13 4.32 35.64 3.94C35.55 3.4 34.11 2.77 32.13 2.57M11.79 17.84C11.9 19.17 11.3 20.06 11.13 20.34C10.86 20.8 10.79 21.23 10.94 21.79C11.11 22.41 11.94 24.59 12.04 25.94C12.06 26.18 12.02 27.14 12.17 27.41C12.39 27.81 13.01 27.63 13.16 27.98C13.25 28.17 13.08 28.34 13.1 28.62C13.12 28.82 13.12 29.1 13.54 29.1H14.56C14.98 29.1 15.2 29.08 15.07 28.76C14.92 28.39 14.62 27.94 14.34 27.66C14.21 27.49 13.83 26.76 13.69 26.57C13.22 25.98 13.02 23.57 12.93 22.16C12.92 21.95 13.12 21.01 13.35 20.65C14.15 19.37 15.2 18.75 15.86 16.97"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}

export function BoulevardStage({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="30"
      height="25"
      viewBox="0 0 30 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.74 9.73L15.07 3.93M15.07 3.93L22.39 9.73M15.07 3.93V9.88M29.63 24.3H0.5M27.92 24.3L26.75 13.41M10.33 24.3C12.19 22.89 14.34 20.11 15.06 17.56C15.79 20.07 18.07 22.88 19.84 24.3M3.38 13.41L2.21 24.3M27.72 9.82L15.27 1.07C15.15 0.980002 14.98 0.980002 14.85 1.07L2.41 9.83C2.31 9.9 2.26 10.01 2.26 10.13V10.96C2.26 12.76 3.73 14.23 5.53 14.23C6.44 14.23 7.3 13.85 7.92 13.2C8.53 13.85 9.4 14.23 10.3 14.23C11.2 14.23 12.07 13.85 12.68 13.2C13.29 13.85 14.16 14.23 15.06 14.23C15.96 14.23 16.83 13.85 17.44 13.2C18.06 13.85 18.92 14.23 19.82 14.23C20.72 14.23 21.59 13.85 22.2 13.2C22.81 13.85 23.68 14.23 24.58 14.23C26.39 14.23 27.85 12.76 27.85 10.96V10.13C27.85 10.01 27.79 9.9 27.7 9.83L27.72 9.82Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}

export function KidsMidWeek({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.77 6.66C0.77 7.68 5.62 8.49 11.61 8.49C17.6 8.49 22.45 7.67 22.45 6.66C22.45 5.76 18.55 5 13.43 4.86M22.45 10.05C22.45 11.06 17.6 11.88 11.61 11.88M11.61 11.88C5.62 11.88 0.77 11.07 0.77 10.05M11.61 11.88L6.89 18.33L3.52 11.36L0.77 16.74C0.77 17.75 5.62 18.57 11.61 18.57C17.6 18.57 22.45 17.75 22.45 16.74L19.69 11.31L16.33 18.33L11.61 11.88ZM0.77 6.67C0.77 5.77 4.63 5.02 9.71 4.87M22.45 6.65V20.37C22.45 21.38 17.6 22.2 11.61 22.2C5.62 22.2 0.77 21.39 0.77 20.37L0.75 15.7V6.68M13.19 3.87L20.91 0.75M13.44 4.79C13.44 5.82 12.61 6.65 11.58 6.65C10.55 6.65 9.72 5.82 9.72 4.79C9.72 3.76 10.55 2.93 11.58 2.93C12.61 2.93 13.44 3.76 13.44 4.79Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}

export function NightShift({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="32"
      height="28"
      viewBox="0 0 32 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.89 7.15V5.19M10.89 2.77V1.82M10.89 10.73V12.69M10.89 15.1V16.06M10.28 7.26L9.6 5.41M8.78 3.14L8.45 2.24M11.5 10.62L12.17 12.46M13 14.73L13.32 15.63M9.74 7.57L8.48 6.06M6.92 4.22L6.31 3.48M12.04 10.31L13.3 11.81M14.85 13.66L15.47 14.4M12.04 7.57L13.3 6.06M14.85 4.22L15.47 3.48M9.74 10.31L8.48 11.81M6.92 13.66L6.31 14.4M9.34 8.04L7.64 7.06M5.55 5.86L4.72 5.38M12.44 9.83L14.14 10.81M16.23 12.02L17.06 12.5M9.12 8.63L7.19 8.29M4.82 7.87L3.87 7.7M12.65 9.25L14.58 9.59M16.96 10.01L17.9 10.18M11.5 7.26L12.17 5.41M13 3.14L13.32 2.24M10.28 10.62L9.6 12.46M8.78 14.73L8.45 15.63M12.44 8.04L14.14 7.06M16.23 5.86L17.06 5.38M9.07 9.99L7.64 10.81M5.55 12.02L4.72 12.5M12.65 8.63L14.58 8.29M16.96 7.87L17.9 7.7M9.12 9.25L7.19 9.59M4.82 10.01L3.87 10.18M24.06 15.75L23.89 13.8M23.68 11.4L23.6 10.44M24.37 19.32L24.54 21.28M24.75 23.68L24.84 24.63M23.46 15.92L22.63 14.14M21.61 11.95L21.21 11.08M24.97 19.16L25.8 20.94M26.82 23.13L27.23 23.99M22.95 16.27L21.56 14.89M19.86 13.18L19.18 12.5M25.48 18.8L26.87 20.19M28.58 21.9L29.25 22.58M25.24 16.07L26.37 14.47M27.75 12.49L28.3 11.7M23.19 19.01L22.07 20.61M20.68 22.59L20.13 23.37M22.59 16.78L20.82 15.95M18.63 14.93L17.76 14.53M25.84 18.3L27.62 19.12M29.81 20.14L30.67 20.55M22.43 17.38L20.48 17.21M18.08 17L17.12 16.92M26 17.69L27.95 17.87M30.36 18.08L31.31 18.16M24.68 15.81L25.19 13.91M25.81 11.58L26.06 10.66M23.75 19.27L23.25 21.16M22.62 23.49L22.37 24.42M25.68 16.51L27.29 15.39M29.27 14L30.05 13.45M22.5 18.74L21.14 19.69M19.17 21.07L18.38 21.62M25.95 17.07L27.84 16.57M30.17 15.94L31.1 15.69M22.49 18L20.59 18.51M18.26 19.13L17.34 19.38M5.39 20.54L5.22 18.59M5.7 24.11L5.88 26.07M4.79 20.7L3.96 18.93M6.3 23.95L7.13 25.73M4.28 21.06L2.9 19.68M6.81 23.59L8.2 24.98M6.58 20.86L7.7 19.25M4.52 23.8L3.4 25.4M3.92 21.57L2.15 20.74M7.17 23.08L8.95 23.91M3.76 22.17L1.81 22M7.33 22.48L9.29 22.65M6.01 20.6L6.52 18.7M5.08 24.06L4.58 25.95M7.02 21.3L8.62 20.18M3.83 23.53L2.47 24.48M7.28 21.86L9.17 21.36M3.82 22.79L1.92 23.3M11 3.98C11 4.04075 10.9508 4.09 10.89 4.09C10.8292 4.09 10.78 4.04075 10.78 3.98C10.78 3.91925 10.8292 3.87 10.89 3.87C10.9508 3.87 11 3.91925 11 3.98ZM11 0.61C11 0.670751 10.9508 0.72 10.89 0.72C10.8292 0.72 10.78 0.670751 10.78 0.61C10.78 0.549249 10.8292 0.5 10.89 0.5C10.9508 0.5 11 0.549249 11 0.61ZM11 13.9C11 13.84 10.95 13.79 10.89 13.79C10.83 13.79 10.78 13.84 10.78 13.9C10.78 13.96 10.83 14.01 10.89 14.01C10.95 14.01 11 13.96 11 13.9ZM11 17.27C11 17.3308 10.9508 17.38 10.89 17.38C10.8292 17.38 10.78 17.3308 10.78 17.27C10.78 17.2092 10.8292 17.16 10.89 17.16C10.9508 17.16 11 17.2092 11 17.27ZM9.29 4.24C9.31 4.3 9.29 4.36 9.23 4.38C9.17 4.4 9.11 4.38 9.09 4.32C9.07 4.26 9.09 4.2 9.15 4.18C9.21 4.16 9.27 4.18 9.29 4.24ZM8.14 1.07C8.16 1.13 8.14 1.19 8.08 1.21C8.02 1.23 7.96 1.21 7.94 1.15C7.92 1.09 7.94 1.03 8 1.01C8.06 0.99 8.12 1.01 8.14 1.07ZM12.69 13.56C12.67 13.5 12.61 13.47 12.55 13.5C12.49 13.53 12.46 13.58 12.49 13.64C12.51 13.7 12.57 13.73 12.63 13.7C12.69 13.68 12.72 13.62 12.69 13.56ZM13.84 16.73C13.82 16.67 13.76 16.64 13.7 16.67C13.64 16.69 13.61 16.75 13.64 16.81C13.67 16.87 13.72 16.9 13.78 16.87C13.84 16.84 13.87 16.79 13.84 16.73ZM7.78 5.07C7.78 5.07 7.81 5.18 7.77 5.22C7.72 5.26 7.66 5.25 7.62 5.21C7.58 5.16 7.59 5.1 7.63 5.06C7.68 5.02 7.74 5.03 7.78 5.07ZM5.62 2.49C5.62 2.49 5.65 2.6 5.61 2.64C5.56 2.68 5.5 2.67 5.46 2.63C5.42 2.58 5.43 2.52 5.47 2.48C5.52 2.44 5.58 2.45 5.62 2.49ZM14.16 12.67C14.16 12.67 14.05 12.62 14.01 12.66C13.96 12.7 13.96 12.77 14 12.81C14.04 12.86 14.11 12.86 14.15 12.82C14.2 12.78 14.2 12.71 14.16 12.67ZM16.33 15.25C16.33 15.25 16.22 15.2 16.18 15.24C16.13 15.28 16.13 15.35 16.17 15.39C16.21 15.44 16.28 15.44 16.32 15.4C16.37 15.36 16.37 15.29 16.33 15.25ZM13.99 5.07C13.99 5.07 13.96 5.18 14 5.22C14.05 5.26 14.11 5.25 14.15 5.21C14.19 5.16 14.18 5.1 14.14 5.06C14.09 5.02 14.03 5.03 13.99 5.07ZM16.16 2.49C16.16 2.49 16.13 2.6 16.17 2.64C16.22 2.68 16.28 2.67 16.32 2.63C16.36 2.58 16.35 2.52 16.31 2.48C16.26 2.44 16.2 2.45 16.16 2.49ZM7.62 12.67C7.62 12.67 7.73 12.62 7.77 12.66C7.82 12.7 7.82 12.77 7.78 12.81C7.74 12.86 7.67 12.86 7.63 12.82C7.58 12.78 7.58 12.71 7.62 12.67ZM5.45 15.25C5.45 15.25 5.56 15.2 5.6 15.24C5.65 15.28 5.65 15.35 5.61 15.39C5.57 15.43 5.5 15.44 5.46 15.4C5.41 15.36 5.41 15.29 5.45 15.25ZM6.65 6.37C6.7 6.4 6.72 6.47 6.69 6.52C6.66 6.57 6.59 6.59 6.54 6.56C6.49 6.53 6.47 6.46 6.5 6.41C6.53 6.36 6.6 6.34 6.65 6.37ZM3.73 4.68C3.78 4.71 3.8 4.78 3.77 4.83C3.74 4.88 3.67 4.9 3.62 4.87C3.57 4.84 3.55 4.77 3.58 4.72C3.61 4.67 3.68 4.65 3.73 4.68ZM15.24 11.32C15.19 11.29 15.12 11.31 15.09 11.36C15.06 11.41 15.08 11.48 15.13 11.51C15.18 11.54 15.25 11.52 15.28 11.47C15.31 11.42 15.29 11.35 15.24 11.32ZM18.16 13.01C18.11 12.98 18.04 13 18.01 13.05C17.98 13.1 18 13.17 18.05 13.2C18.1 13.23 18.17 13.21 18.2 13.16C18.23 13.11 18.21 13.04 18.16 13.01ZM6.02 7.97C6.08 7.98 6.12 8.04 6.11 8.1C6.1 8.16 6.04 8.2 5.98 8.19C5.92 8.18 5.88 8.12 5.89 8.06C5.9 8 5.96 7.96 6.02 7.97ZM2.7 7.39C2.76 7.4 2.8 7.46 2.79 7.52C2.78 7.58 2.72 7.62 2.66 7.61C2.6 7.6 2.56 7.54 2.57 7.48C2.58 7.42 2.64 7.38 2.7 7.39ZM15.79 9.69C15.73 9.68 15.68 9.72 15.66 9.78C15.65 9.84 15.69 9.89 15.75 9.91C15.81 9.92 15.86 9.88 15.88 9.82C15.89 9.76 15.85 9.71 15.79 9.69ZM19.11 10.28C19.05 10.27 19 10.31 18.98 10.37C18.97 10.43 19.01 10.48 19.07 10.5C19.13 10.51 19.18 10.47 19.2 10.41C19.21 10.35 19.17 10.3 19.11 10.28ZM12.48 4.24C12.46 4.3 12.48 4.36 12.54 4.38C12.6 4.4 12.66 4.38 12.68 4.32C12.7 4.26 12.68 4.2 12.62 4.18C12.56 4.16 12.5 4.18 12.48 4.24ZM13.64 1.07C13.62 1.13 13.64 1.19 13.7 1.21C13.76 1.23 13.82 1.21 13.84 1.15C13.86 1.09 13.84 1.03 13.78 1.01C13.72 0.99 13.66 1.01 13.64 1.07ZM9.09 13.56C9.11 13.5 9.17 13.47 9.23 13.5C9.29 13.52 9.32 13.58 9.29 13.64C9.27 13.7 9.21 13.73 9.15 13.7C9.09 13.68 9.06 13.62 9.09 13.56ZM7.94 16.73C7.96 16.67 8.02 16.64 8.08 16.67C8.14 16.7 8.17 16.75 8.14 16.81C8.11 16.87 8.06 16.9 8 16.87C7.94 16.84 7.91 16.79 7.94 16.73ZM15.13 6.37C15.08 6.4 15.06 6.47 15.09 6.52C15.12 6.57 15.19 6.59 15.24 6.56C15.29 6.53 15.31 6.46 15.28 6.41C15.25 6.36 15.18 6.34 15.13 6.37ZM18.05 4.68C18 4.71 17.98 4.78 18.01 4.83C18.04 4.88 18.11 4.9 18.16 4.87C18.21 4.84 18.23 4.77 18.2 4.72C18.17 4.67 18.1 4.65 18.05 4.68ZM6.54 11.32C6.59 11.29 6.66 11.31 6.69 11.36C6.72 11.41 6.7 11.48 6.65 11.51C6.6 11.54 6.53 11.52 6.5 11.47C6.47 11.42 6.49 11.35 6.54 11.32ZM3.62 13.01C3.67 12.98 3.74 13 3.77 13.05C3.8 13.1 3.78 13.17 3.73 13.2C3.68 13.23 3.61 13.21 3.58 13.16C3.55 13.11 3.57 13.04 3.62 13.01ZM15.75 7.97C15.69 7.98 15.65 8.04 15.66 8.1C15.67 8.16 15.73 8.2 15.79 8.19C15.85 8.18 15.89 8.12 15.88 8.06C15.87 8 15.81 7.96 15.75 7.97ZM19.07 7.39C19.01 7.4 18.97 7.46 18.98 7.52C18.99 7.58 19.05 7.62 19.11 7.61C19.17 7.6 19.21 7.54 19.2 7.48C19.19 7.42 19.13 7.38 19.07 7.39ZM5.99 9.69C6.05 9.68 6.1 9.72 6.12 9.78C6.13 9.84 6.09 9.89 6.03 9.91C5.97 9.92 5.91 9.88 5.9 9.82C5.89 9.76 5.93 9.71 5.99 9.69ZM2.67 10.28C2.73 10.27 2.79 10.31 2.8 10.37C2.81 10.43 2.77 10.48 2.71 10.5C2.65 10.51 2.6 10.47 2.58 10.41C2.57 10.35 2.61 10.3 2.67 10.28ZM23.89 12.59C23.89 12.65 23.85 12.7 23.79 12.71C23.73 12.72 23.68 12.67 23.67 12.61C23.66 12.55 23.71 12.5 23.77 12.49C23.83 12.49 23.88 12.53 23.89 12.59ZM24.76 22.47C24.76 22.41 24.7 22.37 24.64 22.37C24.58 22.37 24.54 22.43 24.54 22.49C24.54 22.55 24.6 22.59 24.66 22.59C24.72 22.59 24.76 22.53 24.76 22.47ZM22.22 13C22.25 13.05 22.22 13.12 22.17 13.14C22.12 13.16 22.05 13.14 22.03 13.09C22 13.04 22.03 12.97 22.08 12.95C22.13 12.92 22.2 12.95 22.22 13ZM26.41 21.99C26.38 21.94 26.32 21.91 26.27 21.94C26.22 21.97 26.19 22.03 26.22 22.08C26.25 22.13 26.31 22.16 26.36 22.13C26.41 22.1 26.44 22.04 26.41 21.99ZM20.79 13.96C20.79 13.96 20.83 14.07 20.79 14.11C20.75 14.15 20.68 14.15 20.64 14.11C20.6 14.07 20.6 14 20.64 13.96C20.68 13.92 20.75 13.92 20.79 13.96ZM27.83 21.04C27.83 21.1008 27.7808 21.15 27.72 21.15C27.6592 21.15 27.61 21.1008 27.61 21.04C27.61 20.9792 27.6592 20.93 27.72 20.93C27.7808 20.93 27.83 20.9792 27.83 21.04ZM26.97 13.41C26.97 13.41 26.95 13.53 27 13.56C27.05 13.59 27.12 13.58 27.15 13.53C27.18 13.48 27.17 13.41 27.12 13.38C27.07 13.35 27 13.36 26.97 13.41ZM21.28 21.54C21.28 21.54 21.38 21.48 21.43 21.51C21.48 21.54 21.49 21.61 21.46 21.66C21.43 21.71 21.36 21.72 21.31 21.69C21.26 21.66 21.25 21.59 21.28 21.54ZM19.77 15.34C19.82 15.37 19.85 15.43 19.82 15.48C19.79 15.53 19.73 15.56 19.68 15.53C19.63 15.5 19.6 15.44 19.63 15.39C19.66 15.34 19.72 15.31 19.77 15.34ZM28.76 19.54C28.71 19.51 28.64 19.54 28.62 19.59C28.59 19.64 28.62 19.71 28.67 19.73C28.72 19.75 28.79 19.73 28.81 19.68C28.84 19.63 28.81 19.56 28.76 19.54ZM19.29 17C19.35 17 19.39 17.06 19.39 17.12C19.39 17.18 19.33 17.22 19.27 17.22C19.21 17.22 19.17 17.16 19.17 17.1C19.17 17.04 19.23 17 19.29 17ZM29.17 17.86C29.11 17.86 29.06 17.9 29.05 17.96C29.04 18.02 29.09 18.07 29.15 18.08C29.21 18.08 29.26 18.04 29.27 17.98C29.27 17.92 29.23 17.87 29.17 17.86ZM25.4 12.72C25.38 12.78 25.42 12.84 25.48 12.85C25.54 12.87 25.6 12.83 25.61 12.77C25.63 12.71 25.59 12.65 25.53 12.64C25.47 12.62 25.41 12.66 25.4 12.72ZM22.83 22.3C22.85 22.24 22.9 22.21 22.96 22.22C23.02 22.23 23.05 22.29 23.04 22.35C23.02 22.41 22.97 22.44 22.91 22.43C22.85 22.41 22.82 22.36 22.83 22.3ZM28.22 14.61C28.22 14.61 28.16 14.71 28.19 14.76C28.22 14.81 28.29 14.82 28.34 14.79C28.39 14.76 28.4 14.69 28.37 14.64C28.34 14.59 28.27 14.58 28.22 14.61ZM20.09 20.29C20.09 20.29 20.21 20.27 20.24 20.32C20.27 20.37 20.26 20.44 20.21 20.47C20.16 20.5 20.09 20.49 20.06 20.44C20.03 20.39 20.04 20.32 20.09 20.29ZM28.98 16.15C28.92 16.17 28.89 16.22 28.9 16.28C28.92 16.34 28.97 16.37 29.03 16.36C29.09 16.34 29.12 16.29 29.11 16.23C29.09 16.17 29.04 16.14 28.98 16.15ZM19.4 18.72C19.46 18.7 19.52 18.74 19.53 18.8C19.55 18.86 19.51 18.92 19.45 18.93C19.39 18.95 19.33 18.91 19.32 18.85C19.3 18.79 19.34 18.73 19.4 18.72ZM5.22 17.38C5.22 17.44 5.18 17.49 5.12 17.5C5.06 17.51 5.01 17.46 5 17.4C4.99 17.34 5.04 17.29 5.1 17.28C5.16 17.27 5.21 17.32 5.22 17.38ZM6.09 27.26C6.09 27.2 6.03 27.16 5.97 27.16C5.91 27.16 5.87 27.22 5.87 27.28C5.87 27.34 5.93 27.38 5.99 27.38C6.05 27.38 6.09 27.32 6.09 27.26ZM3.55 17.79C3.58 17.84 3.55 17.91 3.5 17.93C3.45 17.95 3.38 17.93 3.36 17.88C3.34 17.83 3.36 17.76 3.41 17.74C3.46 17.72 3.53 17.74 3.55 17.79ZM7.74 26.78C7.71 26.73 7.65 26.7 7.6 26.73C7.55 26.76 7.52 26.82 7.55 26.87C7.58 26.92 7.64 26.95 7.69 26.92C7.74 26.89 7.77 26.83 7.74 26.78ZM2.12 18.75C2.12 18.75 2.16 18.86 2.12 18.9C2.08 18.94 2.01 18.94 1.97 18.9C1.93 18.86 1.93 18.79 1.97 18.75C2.01 18.71 2.08 18.71 2.12 18.75ZM9.13 25.76C9.13 25.76 9.02 25.72 8.98 25.76C8.94 25.8 8.94 25.87 8.98 25.91C9.02 25.95 9.09 25.95 9.13 25.91C9.17 25.87 9.17 25.8 9.13 25.76ZM8.3 18.2C8.3 18.2 8.28 18.32 8.33 18.35C8.38 18.38 8.45 18.37 8.48 18.32C8.51 18.27 8.5 18.2 8.45 18.17C8.4 18.14 8.33 18.15 8.3 18.2ZM2.62 26.33C2.62 26.33 2.72 26.27 2.77 26.3C2.82 26.33 2.83 26.4 2.8 26.45C2.77 26.5 2.7 26.51 2.65 26.48C2.6 26.45 2.59 26.38 2.62 26.33ZM1.1 20.13C1.15 20.16 1.18 20.22 1.15 20.27C1.12 20.32 1.06 20.35 1.01 20.32C0.96 20.29 0.93 20.23 0.96 20.18C0.99 20.13 1.05 20.1 1.1 20.13ZM10.09 24.33C10.04 24.3 9.97 24.33 9.95 24.38C9.92 24.43 9.95 24.5 10 24.52C10.05 24.54 10.12 24.52 10.14 24.47C10.16 24.42 10.14 24.35 10.09 24.33ZM0.62 21.79C0.68 21.79 0.72 21.85 0.72 21.91C0.72 21.97 0.66 22.01 0.6 22.01C0.54 22.01 0.5 21.95 0.5 21.89C0.5 21.83 0.56 21.79 0.62 21.79ZM10.5 22.65C10.44 22.65 10.39 22.69 10.38 22.75C10.37 22.81 10.42 22.86 10.48 22.87C10.54 22.88 10.59 22.83 10.6 22.77C10.61 22.71 10.56 22.66 10.5 22.65ZM6.73 17.51C6.71 17.57 6.75 17.63 6.81 17.64C6.87 17.66 6.93 17.62 6.94 17.56C6.96 17.5 6.92 17.44 6.86 17.43C6.8 17.41 6.74 17.45 6.73 17.51ZM4.16 27.09C4.18 27.03 4.23 27 4.29 27.01C4.35 27.03 4.38 27.08 4.37 27.14C4.35 27.2 4.3 27.23 4.24 27.22C4.18 27.2 4.15 27.15 4.16 27.09ZM9.55 19.4C9.55 19.4 9.49 19.5 9.52 19.55C9.55 19.6 9.62 19.61 9.67 19.58C9.72 19.55 9.73 19.48 9.7 19.43C9.67 19.38 9.6 19.37 9.55 19.4ZM1.42 25.08C1.42 25.08 1.54 25.06 1.57 25.11C1.6 25.16 1.59 25.23 1.54 25.26C1.49 25.29 1.42 25.28 1.39 25.23C1.36 25.18 1.37 25.11 1.42 25.08ZM10.31 20.94C10.25 20.96 10.22 21.01 10.23 21.07C10.25 21.13 10.3 21.16 10.36 21.15C10.42 21.14 10.45 21.08 10.44 21.02C10.42 20.96 10.37 20.93 10.31 20.94ZM0.73 23.51C0.79 23.49 0.85 23.53 0.86 23.59C0.88 23.65 0.84 23.71 0.78 23.72C0.72 23.74 0.66 23.7 0.65 23.64C0.63 23.58 0.67 23.52 0.73 23.51Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}

export function GoyderStage({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="31"
      height="19"
      viewBox="0 0 31 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.1801 15.4C24.1801 15.4 24.2001 15.33 24.1801 15.28C24.1901 15.32 24.1801 15.36 24.1801 15.4ZM24.1801 15.4C24.1401 15.52 23.9901 15.58 23.8701 15.5C23.1401 14.99 22.2001 14.59 21.1401 14.41C20.0801 14.22 19.0601 14.27 18.2001 14.5C18.0201 14.55 17.8701 14.34 17.9801 14.19C18.6601 13.23 19.6801 12.61 20.7801 12.57C21.0001 12.57 21.2301 12.57 21.4601 12.61C21.6301 12.64 21.7901 12.68 21.9501 12.74C22.1901 12.82 22.4101 12.93 22.6201 13.06C22.7601 13.15 22.8901 13.25 23.0101 13.35C23.4501 13.73 23.7901 14.22 24.0201 14.78C24.0901 14.94 24.1401 15.11 24.1901 15.28C24.2001 15.33 24.1901 15.37 24.1901 15.4H24.1801ZM21.9401 12.73C22.1801 12.81 22.4001 12.92 22.6101 13.05M15.5701 14.14C16.8001 16.24 18.9101 17.76 20.5001 18.04C20.7401 18.08 21.0101 18.1 21.2901 18.1C24.0001 18.08 28.1901 15.95 28.8701 12.11L30.3001 4.03C30.3301 3.88 30.3201 3.74 30.2801 3.61C30.2401 3.48 30.1701 3.36 30.0901 3.26C29.9901 3.14 29.8501 3.06 29.7001 3C29.5901 2.96 29.4701 2.94 29.3501 2.94C29.2201 2.94 29.0801 2.95 28.9301 2.96C28.9101 2.96 28.8801 2.96 28.8601 2.96C28.7101 2.96 28.5601 2.96 28.3901 2.97C28.3601 2.97 28.3301 2.97 28.3001 2.97C28.1301 2.97 27.9501 2.97 27.7701 2.97C27.7501 2.97 27.7301 2.97 27.7101 2.97C27.3201 2.97 26.9001 2.96 26.4601 2.94C26.4401 2.94 26.4201 2.94 26.4001 2.94C26.1901 2.93 25.9601 2.92 25.7401 2.9C25.7101 2.9 25.6801 2.9 25.6601 2.9C25.4301 2.88 25.2001 2.86 24.9701 2.84C24.9501 2.84 24.9301 2.84 24.9201 2.84C24.6801 2.81 24.4301 2.79 24.1801 2.75C23.8701 2.71 23.5701 2.66 23.2501 2.61C20.8001 2.18 18.6201 1.36 17.3901 0.839998C16.8401 0.609998 16.2201 0.949998 16.1201 1.54L15.6001 4.5M16.3901 9.6L14.9601 1.52C14.8601 0.929999 14.2401 0.589998 13.6901 0.819998C13.5701 0.869998 13.4301 0.929998 13.2901 0.979998C13.2701 0.979998 13.2501 0.999999 13.2301 0.999999C13.0901 1.06 12.9401 1.11 12.7901 1.17C12.7601 1.17 12.7401 1.19 12.7101 1.2C12.5501 1.26 12.3901 1.32 12.2101 1.38C12.1901 1.38 12.1701 1.39 12.1501 1.4C11.7801 1.53 11.3801 1.67 10.9601 1.8C10.9401 1.8 10.9201 1.81 10.9001 1.82C10.6901 1.88 10.4801 1.95 10.2701 2.01C10.2401 2.01 10.2201 2.03 10.1901 2.03C9.97005 2.09 9.75005 2.15 9.52005 2.21C9.50005 2.21 9.48005 2.21 9.47005 2.22C9.23005 2.28 8.99005 2.34 8.74005 2.39C8.44005 2.46 8.13005 2.52 7.82005 2.57C5.37005 3 3.05005 2.98 1.71005 2.91C1.12005 2.88 0.650051 3.41 0.750051 4L2.18005 12.08C2.93005 16.32 7.95005 18.47 10.5501 18.01C13.1401 17.55 17.1301 13.82 16.3801 9.57L16.3901 9.6ZM3.75005 9.71C3.67005 9.76 3.57005 9.7 3.59005 9.61C3.74005 8.67 4.29005 7.91 5.12005 7.64C5.95005 7.38 6.84005 7.69 7.50005 8.37C7.57005 8.44 7.52005 8.55 7.43005 8.55C6.83005 8.55 6.18005 8.66 5.51005 8.87C4.84005 9.08 4.24005 9.38 3.75005 9.72V9.71ZM6.10005 13.42C6.00005 13.27 6.10005 13.08 6.26005 13.1C7.16005 13.24 8.16005 13.25 9.20005 13.11C9.36005 13.09 9.52005 13.07 9.67005 13.04C10.8801 12.83 11.9801 12.44 12.8901 11.93C12.9101 11.93 12.9301 11.91 12.9401 11.91C13.0501 11.89 13.1401 11.98 13.1501 12.1C13.1501 12.12 13.1501 12.15 13.1501 12.18C12.7001 13.92 11.5901 15.23 10.0901 15.49C8.60005 15.75 7.10005 14.91 6.09005 13.42H6.10005ZM14.1001 7.88C13.5201 7.73 12.8601 7.66 12.1601 7.69C11.4601 7.72 10.8001 7.85 10.2401 8.05C10.1501 8.08 10.0701 7.99 10.1101 7.91C10.5001 7.05 11.2301 6.45 12.1001 6.41C12.9701 6.37 13.7501 6.91 14.2101 7.73C14.2601 7.81 14.1801 7.91 14.0901 7.88H14.1001ZM22.6101 13.06C22.7501 13.15 22.8801 13.25 23.0001 13.35C22.8801 13.24 22.7401 13.14 22.6101 13.06ZM17.0101 6.7C17.0001 6.61 17.1001 6.54 17.1701 6.6C17.6601 6.94 18.2601 7.23 18.9301 7.45C19.6001 7.66 20.2601 7.76 20.8501 7.77C20.9401 7.77 20.9901 7.88 20.9201 7.95C20.2601 8.63 19.3601 8.94 18.5401 8.68C17.7201 8.42 17.1601 7.65 17.0101 6.71V6.7ZM27.6501 8.58C27.1901 9.41 26.4001 9.94 25.5401 9.9C24.6801 9.86 23.9401 9.27 23.5501 8.4C23.5101 8.31 23.5901 8.23 23.6801 8.26C24.2401 8.46 24.9001 8.59 25.6001 8.62C26.3001 8.65 26.9601 8.58 27.5401 8.43C27.6301 8.41 27.7001 8.5 27.6601 8.58H27.6501ZM27.4201 12.58C27.4201 13.03 27.0501 13.4 26.6001 13.4C26.1501 13.4 25.7801 13.03 25.7801 12.58C25.7801 12.25 26.2101 11.37 26.4501 10.9C26.5101 10.77 26.7001 10.77 26.7601 10.9C27.0001 11.37 27.4301 12.26 27.4301 12.58H27.4201Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}

export function HorticultureStage({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="26"
      height="43"
      viewBox="0 0 26 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.46994 7.72L3.49994 7.56M8.91994 6.75L9.93994 6.59M2.14994 5.57L3.16994 5.42M8.59994 4.6L9.61994 4.45M1.82994 3.43L2.84994 3.28M8.26994 2.46L9.29994 2.3M9.33994 17.78L10.0999 17.66C13.5999 17.13 16.4999 20.21 15.6299 23.53C15.2799 24.88 15.5499 26.31 16.3699 27.44L18.6599 30.6C19.9099 32.32 20.2099 34.52 19.4799 36.52C18.7599 38.47 17.1399 39.98 15.0999 40.61C12.6599 41.36 10.1199 41.74 7.56994 41.75C5.43994 41.75 3.43994 40.78 2.17994 39.13C0.889941 37.44 0.529941 35.24 1.21994 33.23L2.47994 29.54C2.92994 28.22 2.76994 26.77 2.02994 25.59C0.219941 22.67 2.07994 18.88 5.57994 18.35L6.33994 18.23M10.5299 25.69L7.99994 8.84L9.20994 8.65L8.02994 0.879997L2.60994 1.69L3.77994 9.47L4.98994 9.29L7.53994 26.14M8.52994 36.22L12.5499 35.61M21.0399 28.93L21.3199 21.72C21.4099 19.35 22.3099 16.81 24.7599 15.28C24.7599 15.28 26.8999 19.97 22.6799 24.4M21.3099 21.78C21.3999 19.41 20.6999 16.76 18.3699 15.04C18.3699 15.04 15.8799 19.56 19.7399 24.29M21.3999 19.43L21.5499 15.55C21.6399 13.18 20.9499 10.54 18.6199 8.82C18.6199 8.82 17.1599 11.58 18.3699 15.05M21.5499 15.54C21.6399 13.17 22.5299 10.59 24.9899 9.06M24.9899 9.06C24.9899 9.06 26.2399 11.92 24.7699 15.29M24.9899 9.06L25.2099 3.16M19.5999 9.69C19.6499 8.43 20.0299 7.07 20.6799 6.27C21.1899 5.63 21.7599 5.33 21.9399 5.33L22.0399 2.71M23.9399 9.86C23.9899 8.6 23.8299 7.38 23.1299 6.37C22.8399 5.95 22.2399 5.39 21.9399 5.34M18.6199 8.81L18.8499 2.91M6.50994 28.84C6.26994 27.24 7.36994 25.74 8.96994 25.5C10.5699 25.26 12.0699 26.36 12.3099 27.96C12.5499 29.56 11.4499 31.06 9.84994 31.3C8.24994 31.54 6.74994 30.44 6.50994 28.84Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}

export function Kingsway({ className, strokeWidth }) {
  return (
    <svg
      className={className}
      width="21"
      height="43"
      viewBox="0 0 21 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.01 6.32999L13.28 14.31L11.43 13.57L12.34 10.85L14.2 5.21999L17.01 6.32999ZM17.01 6.32999C18.2 6.08999 19.1 5.08999 19.21 3.86999C19.32 2.65999 18.62 1.50999 17.48 1.05999C16.35 0.609994 15.05 0.959994 14.3 1.90999C13.54 2.86999 13.51 4.20999 14.21 5.19999M18.77 5.12999L13.75 3.12999M2.48004 8.13999L3.51004 7.97999M8.98004 7.15999L10.01 7.00999M2.16004 5.97999L3.19004 5.82999M8.65004 4.99999L9.68004 4.84999M1.83004 3.81999L2.86004 3.66999M8.32004 2.83999L9.36004 2.68999M9.40004 18.27L10.17 18.15C13.7 17.62 16.61 20.71 15.74 24.06C15.38 25.42 15.66 26.86 16.48 28L18.79 31.18C20.05 32.91 20.35 35.13 19.61 37.14C18.89 39.1 17.25 40.63 15.2 41.26C12.74 42.02 10.18 42.4 7.61004 42.4C5.46004 42.4 3.45004 41.42 2.18004 39.76C0.880045 38.06 0.520045 35.85 1.21004 33.82L2.48004 30.1C2.93004 28.77 2.77004 27.31 2.03004 26.12C0.210045 23.18 2.08004 19.36 5.61004 18.83L6.38004 18.71M10.59 26.24L8.05004 9.26999L9.27005 9.07999L8.08004 1.24999L2.62004 2.06999L3.80004 9.90999L5.02004 9.71999L7.59004 26.69M8.59004 36.84L12.63 36.23M10.9 16.21L11.85 16.59L13.13 14.25L11.58 13.63L10.9 16.21ZM6.55004 29.41C6.31004 27.8 7.42004 26.29 9.03004 26.05C10.64 25.81 12.15 26.92 12.39 28.53C12.63 30.14 11.52 31.65 9.91004 31.89C8.30004 32.13 6.79004 31.02 6.55004 29.41Z"
        className="transition-colors duration-300 stroke-header-foreground group-hover:stroke-header"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}
